/* tslint:disable */
/* eslint-disable */
/**
 * Resell BFF Administration Integration Inditex API
 * Resell BFF Administration Integration Inditex API
 *
 * The version of the OpenAPI document: 32.7.0
 * Contact: isaacrja@ext.inditex.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'addressType'?: AddressAddressTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'street'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'streetInfo'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'extra'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'postalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'provinceState'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'provinceCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'shipmentId'?: string;
}

export const AddressAddressTypeEnum = {
    Postal: 'POSTAL',
    Drop: 'DROP'
} as const;

export type AddressAddressTypeEnum = typeof AddressAddressTypeEnum[keyof typeof AddressAddressTypeEnum];

/**
 * 
 * @export
 * @interface AddressRequest
 */
export interface AddressRequest {
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    'street'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    'streetInfo'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    'extra'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    'postalCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    'provinceState'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    'provinceCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressRequest
     */
    'city'?: string;
}
/**
 * 
 * @export
 * @interface AgeContentFilter
 */
export interface AgeContentFilter {
    /**
     * 
     * @type {string}
     * @memberof AgeContentFilter
     */
    'type': string;
    /**
     * Maximum acceptable age in days
     * @type {number}
     * @memberof AgeContentFilter
     */
    'maxAgeInDays'?: number;
}
/**
 * 
 * @export
 * @interface AgeContentFilters
 */
export interface AgeContentFilters {
    /**
     * 
     * @type {string}
     * @memberof AgeContentFilters
     */
    'type': string;
    /**
     * Maximum acceptable age in days
     * @type {number}
     * @memberof AgeContentFilters
     */
    'maxAgeInDays'?: number;
}
/**
 * Age-based filter criterion
 * @export
 * @interface AgeGridFilterCriterion
 */
export interface AgeGridFilterCriterion extends GridFilterCriterion {
    /**
     * Maximum acceptable age in days
     * @type {number}
     * @memberof AgeGridFilterCriterion
     */
    'maxAgeInDays'?: number;
}


/**
 * 
 * @export
 * @interface AgeGridFilterCriterionAllOf
 */
export interface AgeGridFilterCriterionAllOf {
    /**
     * Maximum acceptable age in days
     * @type {number}
     * @memberof AgeGridFilterCriterionAllOf
     */
    'maxAgeInDays'?: number;
}
/**
 * 
 * @export
 * @interface Ammount
 */
export interface Ammount {
    /**
     * 
     * @type {number}
     * @memberof Ammount
     */
    'amount'?: number;
    /**
     * 
     * @type {number}
     * @memberof Ammount
     */
    'exponent'?: number;
    /**
     * 
     * @type {string}
     * @memberof Ammount
     */
    'currency'?: string;
}
/**
 * 
 * @export
 * @interface AuthTokenResponse
 */
export interface AuthTokenResponse {
    /**
     * 
     * @type {string}
     * @memberof AuthTokenResponse
     */
    'token'?: string;
}
/**
 * 
 * @export
 * @interface Blacklist
 */
export interface Blacklist {
    /**
     * Blacklist ID
     * @type {string}
     * @memberof Blacklist
     */
    'id': string;
    /**
     * Blacklist name
     * @type {string}
     * @memberof Blacklist
     */
    'name': string;
    /**
     * Username
     * @type {string}
     * @memberof Blacklist
     */
    'changeBy'?: string;
    /**
     * Creation or update date
     * @type {string}
     * @memberof Blacklist
     */
    'creationDate'?: string;
    /**
     * Creation or update date
     * @type {string}
     * @memberof Blacklist
     */
    'lastUpdate'?: string;
}
/**
 * 
 * @export
 * @interface BlacklistCreationParams
 */
export interface BlacklistCreationParams {
    /**
     * Blacklist ID
     * @type {string}
     * @memberof BlacklistCreationParams
     */
    'blacklistId': string;
    /**
     * Blacklist name
     * @type {string}
     * @memberof BlacklistCreationParams
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface CategoryContentFilter
 */
export interface CategoryContentFilter {
    /**
     * 
     * @type {string}
     * @memberof CategoryContentFilter
     */
    'type': string;
    /**
     * list of search values
     * @type {Array<number>}
     * @memberof CategoryContentFilter
     */
    'values'?: Array<number>;
}
/**
 * 
 * @export
 * @interface CategoryContentFilters
 */
export interface CategoryContentFilters {
    /**
     * 
     * @type {string}
     * @memberof CategoryContentFilters
     */
    'type': string;
    /**
     * list of search values
     * @type {Array<number>}
     * @memberof CategoryContentFilters
     */
    'values'?: Array<number>;
}
/**
 * Category-based filter criterion
 * @export
 * @interface CategoryGridFilterCriterion
 */
export interface CategoryGridFilterCriterion extends GridFilterCriterion {
    /**
     * Ids of the entities accepted by this filter
     * @type {Array<number>}
     * @memberof CategoryGridFilterCriterion
     */
    'values'?: Array<number>;
}


/**
 * 
 * @export
 * @interface CategoryGridFilterCriterionAllOf
 */
export interface CategoryGridFilterCriterionAllOf {
    /**
     * Ids of the entities accepted by this filter
     * @type {Array<number>}
     * @memberof CategoryGridFilterCriterionAllOf
     */
    'values'?: Array<number>;
}
/**
 * Returns the result of the text evaluation.
 * @export
 * @interface CheckingResult
 */
export interface CheckingResult {
    /**
     * List of tokens that match with the related text by blakclist.
     * @type {Array<TokenCheckMatch>}
     * @memberof CheckingResult
     */
    'matches'?: Array<TokenCheckMatch>;
}
/**
 * Check a set of texts with the specificated blacklists
 * @export
 * @interface CheckingSingleText
 */
export interface CheckingSingleText {
    /**
     * Blacklist IDs
     * @type {Set<string>}
     * @memberof CheckingSingleText
     */
    'blacklistIds'?: Set<string>;
    /**
     * Text to be checked
     * @type {string}
     * @memberof CheckingSingleText
     */
    'text': string;
    /**
     * Locale with modifier
     * @type {string}
     * @memberof CheckingSingleText
     */
    'locale'?: string;
    /**
     * ID of store text was requested at
     * @type {string}
     * @memberof CheckingSingleText
     */
    'storeId'?: string;
    /**
     * In addition to normal blacklist check, also check with all items of this list removed from text and blacklist tokens
     * @type {Array<string>}
     * @memberof CheckingSingleText
     */
    'deepCheckChars'?: Array<string> | null;
    /**
     * App code
     * @type {string}
     * @memberof CheckingSingleText
     */
    'appCode'?: string;
}
/**
 * 
 * @export
 * @interface ColorType
 */
export interface ColorType {
    /**
     * product color type id
     * @type {number}
     * @memberof ColorType
     */
    'colorTypeId'?: number;
    /**
     * product color type description
     * @type {string}
     * @memberof ColorType
     */
    'colorTypeDesc'?: string;
}
/**
 * 
 * @export
 * @interface ColorTypeResponse
 */
export interface ColorTypeResponse {
    /**
     * list colorType
     * @type {Array<ColorType>}
     * @memberof ColorTypeResponse
     */
    'colorTypeList'?: Array<ColorType>;
}
/**
 * 
 * @export
 * @interface CommonFixProperties
 */
export interface CommonFixProperties {
    /**
     * fix type id
     * @type {number}
     * @memberof CommonFixProperties
     */
    'fixTypeId'?: number;
    /**
     * fix type description
     * @type {string}
     * @memberof CommonFixProperties
     */
    'fixTypeDesc'?: string;
    /**
     * fix type description
     * @type {string}
     * @memberof CommonFixProperties
     */
    'fixTypeLongDesc'?: string;
    /**
     * subvention amount to be discounted from the price of a fix
     * @type {number}
     * @memberof CommonFixProperties
     */
    'subventionAmount'?: number;
    /**
     * currency
     * @type {string}
     * @memberof CommonFixProperties
     */
    'currency'?: string;
    /**
     * pmocacota
     * @type {string}
     * @memberof CommonFixProperties
     */
    'pmocacota'?: string;
}
/**
 * @type Content
 * @export
 */
export type Content = { type: 'age' } & AgeContentFilter | { type: 'category' } & CategoryContentFilter | { type: 'option' } & OptionContentFilter | { type: 'search' } & SearchContentFilter;

/**
 * @type Contents
 * @export
 */
export type Contents = { type: 'age' } & AgeContentFilters | { type: 'category' } & CategoryContentFilters | { type: 'option' } & OptionContentFilters | { type: 'search' } & SearchContentFilters;

/**
 * 
 * @export
 * @interface Criteria
 */
export interface Criteria {
    /**
     * List of all filter definition
     * @type {Array<Content>}
     * @memberof Criteria
     */
    'criteria'?: Array<Content>;
}
/**
 * 
 * @export
 * @interface Criterion
 */
export interface Criterion {
    /**
     * 
     * @type {Array<number>}
     * @memberof Criterion
     */
    'category'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof Criterion
     */
    'color'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof Criterion
     */
    'condition'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof Criterion
     */
    'size'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof Criterion
     */
    'age'?: string;
    /**
     * 
     * @type {Array<SearchCriteria>}
     * @memberof Criterion
     */
    'search'?: Array<SearchCriteria>;
}
/**
 * 
 * @export
 * @interface DecryptTokenRequest
 */
export interface DecryptTokenRequest {
    /**
     * 
     * @type {string}
     * @memberof DecryptTokenRequest
     */
    'token'?: string;
}
/**
 * 
 * @export
 * @interface DonateOnline
 */
export interface DonateOnline {
    /**
     * 
     * @type {number}
     * @memberof DonateOnline
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DonateOnline
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DonateOnline
     */
    'surname'?: string;
    /**
     * 
     * @type {string}
     * @memberof DonateOnline
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof DonateOnline
     */
    'phone'?: string;
    /**
     * 
     * @type {Address}
     * @memberof DonateOnline
     */
    'pickupAddress'?: Address;
    /**
     * 
     * @type {boolean}
     * @memberof DonateOnline
     */
    'termsAndConditions'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DonateOnline
     */
    'status'?: DonateOnlineStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof DonateOnline
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof DonateOnline
     */
    'updatedDate'?: string;
    /**
     * 
     * @type {PaymentIntent}
     * @memberof DonateOnline
     */
    'paymentIntent'?: PaymentIntent;
    /**
     * 
     * @type {Array<TrackingEvent>}
     * @memberof DonateOnline
     */
    'trackingEventsPickup'?: Array<TrackingEvent>;
    /**
     * 
     * @type {ShippingCost}
     * @memberof DonateOnline
     */
    'ShippingCost'?: ShippingCost;
    /**
     * 
     * @type {string}
     * @memberof DonateOnline
     */
    'sst'?: string;
}

export const DonateOnlineStatusEnum = {
    Created: 'CREATED',
    PaymentPending: 'PAYMENT_PENDING',
    PaymentError: 'PAYMENT_ERROR',
    PaymentProccess: 'PAYMENT_PROCCESS',
    PaymentSucces: 'PAYMENT_SUCCES',
    ShippingPending: 'SHIPPING_PENDING',
    OnTransit: 'ON_TRANSIT',
    ShippingError: 'SHIPPING_ERROR',
    PendingReview: 'PENDING_REVIEW',
    Accepted: 'ACCEPTED',
    Canceled: 'CANCELED',
    FinishedRepair: 'FINISHED_REPAIR',
    FinishedRepairError: 'FINISHED_REPAIR_ERROR',
    ShippingPendingClient: 'SHIPPING_PENDING_CLIENT',
    ShippingErrorClient: 'SHIPPING_ERROR_CLIENT',
    OnTransitClient: 'ON_TRANSIT_CLIENT',
    Delivered: 'DELIVERED',
    Finish: 'FINISH',
    MqError: 'MQ_ERROR'
} as const;

export type DonateOnlineStatusEnum = typeof DonateOnlineStatusEnum[keyof typeof DonateOnlineStatusEnum];

/**
 * 
 * @export
 * @interface DonateOnlinePaymentRequest
 */
export interface DonateOnlinePaymentRequest {
    /**
     * 
     * @type {string}
     * @memberof DonateOnlinePaymentRequest
     */
    'transactionId'?: string;
    /**
     * 
     * @type {number}
     * @memberof DonateOnlinePaymentRequest
     */
    'totalPrice'?: number;
}
/**
 * 
 * @export
 * @interface DonateOnlineRequest
 */
export interface DonateOnlineRequest {
    /**
     * 
     * @type {string}
     * @memberof DonateOnlineRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DonateOnlineRequest
     */
    'surname'?: string;
    /**
     * 
     * @type {string}
     * @memberof DonateOnlineRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof DonateOnlineRequest
     */
    'phone'?: string;
    /**
     * 
     * @type {AddressRequest}
     * @memberof DonateOnlineRequest
     */
    'pickupAddress'?: AddressRequest;
    /**
     * 
     * @type {boolean}
     * @memberof DonateOnlineRequest
     */
    'termsAndConditions'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DonateOnlineRequest
     */
    'shippingCostId'?: number;
}
/**
 * Datos del error 
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
    /**
     * Código de error
     * @type {string}
     * @memberof ErrorResponse
     */
    'errorCode'?: string;
    /**
     * Descripción del error
     * @type {string}
     * @memberof ErrorResponse
     */
    'errorDescription'?: string;
}
/**
 * 
 * @export
 * @interface FilterDefinitionRequest
 */
export interface FilterDefinitionRequest {
    /**
     * 
     * @type {Criterion}
     * @memberof FilterDefinitionRequest
     */
    'criteria'?: Criterion;
}
/**
 * 
 * @export
 * @interface FixType
 */
export interface FixType {
    /**
     * fix type id
     * @type {number}
     * @memberof FixType
     */
    'fixTypeId'?: number;
    /**
     * fix type description
     * @type {string}
     * @memberof FixType
     */
    'fixTypeDesc'?: string;
    /**
     * fix type description
     * @type {string}
     * @memberof FixType
     */
    'fixTypeLongDesc'?: string;
    /**
     * subvention amount to be discounted from the price of a fix
     * @type {number}
     * @memberof FixType
     */
    'subventionAmount'?: number;
    /**
     * currency
     * @type {string}
     * @memberof FixType
     */
    'currency'?: string;
    /**
     * pmocacota
     * @type {string}
     * @memberof FixType
     */
    'pmocacota'?: string;
    /**
     * price of a fix
     * @type {number}
     * @memberof FixType
     */
    'price'?: number;
    /**
     * price result of the price of a fix minus the subsidized amount
     * @type {number}
     * @memberof FixType
     */
    'subsidizedPrice'?: number;
}
/**
 * 
 * @export
 * @interface FixTypeAllOf
 */
export interface FixTypeAllOf {
    /**
     * price of a fix
     * @type {number}
     * @memberof FixTypeAllOf
     */
    'price'?: number;
    /**
     * price result of the price of a fix minus the subsidized amount
     * @type {number}
     * @memberof FixTypeAllOf
     */
    'subsidizedPrice'?: number;
}
/**
 * 
 * @export
 * @interface FixTypeGeneric
 */
export interface FixTypeGeneric {
    /**
     * fix type id
     * @type {number}
     * @memberof FixTypeGeneric
     */
    'fixTypeId'?: number;
    /**
     * fix type description
     * @type {string}
     * @memberof FixTypeGeneric
     */
    'fixTypeDesc'?: string;
    /**
     * fix type description
     * @type {string}
     * @memberof FixTypeGeneric
     */
    'fixTypeLongDesc'?: string;
    /**
     * subvention amount to be discounted from the price of a fix
     * @type {number}
     * @memberof FixTypeGeneric
     */
    'subventionAmount'?: number;
    /**
     * currency
     * @type {string}
     * @memberof FixTypeGeneric
     */
    'currency'?: string;
    /**
     * pmocacota
     * @type {string}
     * @memberof FixTypeGeneric
     */
    'pmocacota'?: string;
    /**
     * price band of a fix
     * @type {string}
     * @memberof FixTypeGeneric
     */
    'price'?: string;
}
/**
 * 
 * @export
 * @interface FixTypeGenericAllOf
 */
export interface FixTypeGenericAllOf {
    /**
     * price band of a fix
     * @type {string}
     * @memberof FixTypeGenericAllOf
     */
    'price'?: string;
}
/**
 * 
 * @export
 * @interface FixTypePriceResponse
 */
export interface FixTypePriceResponse {
    /**
     * list fixType
     * @type {Array<FixTypeGeneric>}
     * @memberof FixTypePriceResponse
     */
    'fixTypePriceList'?: Array<FixTypeGeneric>;
}
/**
 * 
 * @export
 * @interface Grid
 */
export interface Grid {
    /**
     * Grid Id
     * @type {string}
     * @memberof Grid
     */
    'id'?: string;
    /**
     * The universe where it belongs
     * @type {number}
     * @memberof Grid
     */
    'universeId'?: number;
    /**
     * Is Grid the default in the universe
     * @type {boolean}
     * @memberof Grid
     */
    'defaultInUniverse'?: boolean;
    /**
     * 
     * @type {GridFilterDefinition}
     * @memberof Grid
     */
    'filterDefinition'?: GridFilterDefinition;
    /**
     * Grid description in all supported languages.
     * @type {Array<GridDescription>}
     * @memberof Grid
     */
    'descriptions': Array<GridDescription>;
    /**
     * Grid visibility on main menu
     * @type {boolean}
     * @memberof Grid
     */
    'visible'?: boolean;
    /**
     * Grid recategorization excluded
     * @type {boolean}
     * @memberof Grid
     */
    'recategorizationExcluded'?: boolean;
    /**
     * List of grid parents identifiers
     * @type {Array<Grid>}
     * @memberof Grid
     */
    'subgrids'?: Array<Grid>;
    /**
     * List of grid parents identifiers
     * @type {Array<GridSummary>}
     * @memberof Grid
     */
    'parentGrids'?: Array<GridSummary>;
    /**
     * The identifier of the external grid in Shopizer
     * @type {number}
     * @memberof Grid
     */
    'externalGridId'?: number;
    /**
     * The grid filter id
     * @type {string}
     * @memberof Grid
     */
    'gridFilterId'?: string;
    /**
     * Grid published flag
     * @type {boolean}
     * @memberof Grid
     */
    'isPublished'?: boolean;
    /**
     * URL of the mobile resource
     * @type {string}
     * @memberof Grid
     */
    'mobileResourceUrl'?: string;
    /**
     * URL of the desktop resource
     * @type {string}
     * @memberof Grid
     */
    'desktopResourceUrl'?: string;
    /**
     * Grid status
     * @type {string}
     * @memberof Grid
     */
    'status'?: string;
    /**
     * The error code of the grid
     * @type {string}
     * @memberof Grid
     */
    'errorCode'?: string;
    /**
     * The error message of the grid
     * @type {string}
     * @memberof Grid
     */
    'errorMessage'?: string;
    /**
     * Flag to indicate if the grid is auto updatable
     * @type {boolean}
     * @memberof Grid
     */
    'isAutoUpdatable'?: boolean;
}
/**
 * Grid description in all supported languages.
 * @export
 * @interface GridDescription
 */
export interface GridDescription {
    /**
     * ISO 639-1 language code
     * @type {string}
     * @memberof GridDescription
     */
    'languageCode': string;
    /**
     * Entity name
     * @type {string}
     * @memberof GridDescription
     */
    'name'?: string;
    /**
     * Entity title
     * @type {string}
     * @memberof GridDescription
     */
    'title'?: string;
    /**
     * Entity description
     * @type {string}
     * @memberof GridDescription
     */
    'description'?: string;
}
/**
 * Base class for filter criteria
 * @export
 * @interface GridFilterCriterion
 */
export interface GridFilterCriterion {
    /**
     * Criterion type discriminator
     * @type {string}
     * @memberof GridFilterCriterion
     */
    'type': GridFilterCriterionTypeEnum;
}

export const GridFilterCriterionTypeEnum = {
    Category: 'CATEGORY',
    Option: 'OPTION',
    Age: 'AGE',
    Search: 'SEARCH'
} as const;

export type GridFilterCriterionTypeEnum = typeof GridFilterCriterionTypeEnum[keyof typeof GridFilterCriterionTypeEnum];

/**
 * Grid filter definition. This field is immutable once the grid is created.
 * @export
 * @interface GridFilterDefinition
 */
export interface GridFilterDefinition {
    /**
     * List of criteria applied for this filter
     * @type {Array<GridFilterCriterion>}
     * @memberof GridFilterDefinition
     */
    'criteria'?: Array<GridFilterCriterion>;
}
/**
 * 
 * @export
 * @interface GridStatus
 */
export interface GridStatus {
    /**
     * 
     * @type {string}
     * @memberof GridStatus
     */
    'status'?: string;
    /**
     * Error code if any
     * @type {string}
     * @memberof GridStatus
     */
    'errorCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof GridStatus
     */
    'gridId'?: string;
}
/**
 * Grid summary with basic properties.
 * @export
 * @interface GridSummary
 */
export interface GridSummary {
    /**
     * Grid Id
     * @type {string}
     * @memberof GridSummary
     */
    'id'?: string;
    /**
     * Grid position
     * @type {number}
     * @memberof GridSummary
     */
    'position'?: number;
    /**
     * Grid visibility
     * @type {boolean}
     * @memberof GridSummary
     */
    'visible'?: boolean;
    /**
     * Grid description in all supported languages.
     * @type {Array<GridDescription>}
     * @memberof GridSummary
     */
    'descriptions'?: Array<GridDescription>;
}
/**
 * 
 * @export
 * @interface Gridfilter
 */
export interface Gridfilter {
    /**
     * List of all products
     * @type {Array<ProductFilter>}
     * @memberof Gridfilter
     */
    'products'?: Array<ProductFilter>;
    /**
     * 
     * @type {Criteria}
     * @memberof Gridfilter
     */
    'filterDefinition'?: Criteria;
}
/**
 * 
 * @export
 * @interface Gridfilters
 */
export interface Gridfilters {
    /**
     * 
     * @type {string}
     * @memberof Gridfilters
     */
    'operation'?: GridfiltersOperationEnum;
    /**
     * 
     * @type {GridfiltersCriteria}
     * @memberof Gridfilters
     */
    'criteria'?: GridfiltersCriteria;
    /**
     * 
     * @type {Array<number>}
     * @memberof Gridfilters
     */
    'products'?: Array<number>;
}

export const GridfiltersOperationEnum = {
    Add: 'ADD',
    Remove: 'REMOVE'
} as const;

export type GridfiltersOperationEnum = typeof GridfiltersOperationEnum[keyof typeof GridfiltersOperationEnum];

/**
 * 
 * @export
 * @interface GridfiltersCriteria
 */
export interface GridfiltersCriteria {
    /**
     * 
     * @type {Contents}
     * @memberof GridfiltersCriteria
     */
    'definition'?: Contents;
}
/**
 * 
 * @export
 * @interface Group
 */
export interface Group {
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Group
     */
    'isGroup'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'groupReference'?: number;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'groupType'?: string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'groupDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'groupFrontImage'?: string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'groupTitle'?: string;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'store'?: number;
    /**
     * 
     * @type {Array<ProductSize>}
     * @memberof Group
     */
    'sizes'?: Array<ProductSize>;
    /**
     * 
     * @type {ProductPrices}
     * @memberof Group
     */
    'prices'?: ProductPrices;
    /**
     * Grid ids
     * @type {Array<string>}
     * @memberof Group
     */
    'grids'?: Array<string>;
    /**
     * Universe ids
     * @type {Array<string>}
     * @memberof Group
     */
    'universes'?: Array<string>;
}
/**
 * 
 * @export
 * @interface HybridSearchContent
 */
export interface HybridSearchContent {
    /**
     * 
     * @type {number}
     * @memberof HybridSearchContent
     */
    'catalogId'?: number;
    /**
     * 
     * @type {string}
     * @memberof HybridSearchContent
     */
    'sku'?: string;
    /**
     * 
     * @type {string}
     * @memberof HybridSearchContent
     */
    'year'?: string;
    /**
     * 
     * @type {string}
     * @memberof HybridSearchContent
     */
    'productName'?: string;
    /**
     * 
     * @type {string}
     * @memberof HybridSearchContent
     */
    'colorLabel'?: string;
    /**
     * 
     * @type {string}
     * @memberof HybridSearchContent
     */
    'collection'?: string;
    /**
     * 
     * @type {string}
     * @memberof HybridSearchContent
     */
    'frontImage'?: string;
}
/**
 * 
 * @export
 * @interface HybridSearchResponse
 */
export interface HybridSearchResponse {
    /**
     * 
     * @type {Array<HybridSearchContent>}
     * @memberof HybridSearchResponse
     */
    'content'?: Array<HybridSearchContent>;
    /**
     * 
     * @type {PageableObject}
     * @memberof HybridSearchResponse
     */
    'pageable'?: PageableObject;
    /**
     * 
     * @type {number}
     * @memberof HybridSearchResponse
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof HybridSearchResponse
     */
    'totalPages'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof HybridSearchResponse
     */
    'last'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof HybridSearchResponse
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof HybridSearchResponse
     */
    'first'?: boolean;
    /**
     * 
     * @type {Sort}
     * @memberof HybridSearchResponse
     */
    'sort'?: Sort;
    /**
     * 
     * @type {number}
     * @memberof HybridSearchResponse
     */
    'number'?: number;
    /**
     * 
     * @type {number}
     * @memberof HybridSearchResponse
     */
    'size'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof HybridSearchResponse
     */
    'empty'?: boolean;
}
/**
 * 
 * @export
 * @interface IAModerationCoverRetouchDetails
 */
export interface IAModerationCoverRetouchDetails {
    /**
     * 
     * @type {string}
     * @memberof IAModerationCoverRetouchDetails
     */
    'url'?: string;
    /**
     * 
     * @type {number}
     * @memberof IAModerationCoverRetouchDetails
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IAModerationCoverRetouchDetails
     */
    'retouch'?: boolean;
}
/**
 * 
 * @export
 * @interface IAModerationErrors
 */
export interface IAModerationErrors {
    /**
     * 
     * @type {string}
     * @memberof IAModerationErrors
     */
    'errorCode'?: IAModerationErrorsErrorCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof IAModerationErrors
     */
    'detailMessage'?: string;
}

export const IAModerationErrorsErrorCodeEnum = {
    BackViewArticle: 'BACK_VIEW_ARTICLE',
    BadImageQuality: 'BAD_IMAGE_QUALITY',
    BrandImage: 'BRAND_IMAGE',
    CopyrightedImages: 'COPYRIGHTED_IMAGES',
    DuplicatedListing: 'DUPLICATED_LISTING',
    IncompleteDescription: 'INCOMPLETE_DESCRIPTION',
    IncorrectImages: 'INCORRECT_IMAGES',
    InvalidDescription: 'INVALID_DESCRIPTION',
    MoreThanOneArticle: 'MORE_THAN_ONE_ARTICLE',
    NoRealImagesIncluded: 'NO_REAL_IMAGES_INCLUDED',
    NotAllViewsIncluded: 'NOT_ALL_VIEWS_INCLUDED',
    NotEligibleForResell: 'NOT_ELIGIBLE_FOR_RESELL',
    NotFullyCaptured: 'NOT_FULLY_CAPTURED',
    InappropriateImageContent: 'INAPPROPRIATE_IMAGE_CONTENT',
    DuplicatedImages: 'DUPLICATED_IMAGES',
    InappropriateTextContent: 'INAPPROPRIATE_TEXT_CONTENT',
    NoFrontView: 'NO_FRONT_VIEW'
} as const;

export type IAModerationErrorsErrorCodeEnum = typeof IAModerationErrorsErrorCodeEnum[keyof typeof IAModerationErrorsErrorCodeEnum];

/**
 * 
 * @export
 * @interface IAModerationImageDetails
 */
export interface IAModerationImageDetails {
    /**
     * 
     * @type {string}
     * @memberof IAModerationImageDetails
     */
    'url'?: string;
    /**
     * 
     * @type {number}
     * @memberof IAModerationImageDetails
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface IAModerationResponse
 */
export interface IAModerationResponse {
    /**
     * 
     * @type {number}
     * @memberof IAModerationResponse
     */
    'idProduct'?: number;
    /**
     * 
     * @type {number}
     * @memberof IAModerationResponse
     */
    'idStore'?: number;
    /**
     * 
     * @type {IAModerationImageDetails}
     * @memberof IAModerationResponse
     */
    'frontImage'?: IAModerationImageDetails;
    /**
     * 
     * @type {IAModerationImageDetails}
     * @memberof IAModerationResponse
     */
    'backImage'?: IAModerationImageDetails;
    /**
     * 
     * @type {IAModerationCoverRetouchDetails}
     * @memberof IAModerationResponse
     */
    'coverImage'?: IAModerationCoverRetouchDetails;
    /**
     * 
     * @type {number}
     * @memberof IAModerationResponse
     */
    'categoryId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IAModerationResponse
     */
    'isValid'?: boolean;
    /**
     * 
     * @type {Array<IAModerationErrors>}
     * @memberof IAModerationResponse
     */
    'errors'?: Array<IAModerationErrors>;
    /**
     * 
     * @type {boolean}
     * @memberof IAModerationResponse
     */
    'needBackImage'?: boolean;
}
/**
 * 
 * @export
 * @interface ImageData
 */
export interface ImageData {
    /**
     * 
     * @type {number}
     * @memberof ImageData
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ImageData
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface ImageServiceOutput
 */
export interface ImageServiceOutput {
    /**
     * grant type
     * @type {string}
     * @memberof ImageServiceOutput
     */
    'tokenType'?: string;
    /**
     * client id
     * @type {string}
     * @memberof ImageServiceOutput
     */
    'expiresIn'?: string;
    /**
     * client secret
     * @type {string}
     * @memberof ImageServiceOutput
     */
    'extExpiresIn'?: string;
    /**
     * resource
     * @type {string}
     * @memberof ImageServiceOutput
     */
    'expiresOn'?: string;
    /**
     * resource
     * @type {string}
     * @memberof ImageServiceOutput
     */
    'notBefore'?: string;
    /**
     * resource
     * @type {string}
     * @memberof ImageServiceOutput
     */
    'resource'?: string;
    /**
     * resource
     * @type {string}
     * @memberof ImageServiceOutput
     */
    'accessToken'?: string;
}
/**
 * 
 * @export
 * @interface LegacyMedia
 */
export interface LegacyMedia {
    /**
     * type of media
     * @type {string}
     * @memberof LegacyMedia
     */
    'type'?: string;
    /**
     * kind of media
     * @type {string}
     * @memberof LegacyMedia
     */
    'kind'?: string;
    /**
     * width in pixels of the original media
     * @type {number}
     * @memberof LegacyMedia
     */
    'width'?: number;
    /**
     * height in pixels of the original media
     * @type {number}
     * @memberof LegacyMedia
     */
    'height'?: number;
    /**
     * path to the file including filename but no extension
     * @type {string}
     * @memberof LegacyMedia
     */
    'file'?: string;
    /**
     * timestamp when the media was created
     * @type {number}
     * @memberof LegacyMedia
     */
    'timestamp'?: number;
    /**
     * places where the media is configured to be shown
     * @type {Array<MediaPlace>}
     * @memberof LegacyMedia
     */
    'places'?: Array<MediaPlace>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LegacyMedia
     */
    'allowedScreens'?: Array<string>;
    /**
     * index of the original media file when it was created
     * @type {number}
     * @memberof LegacyMedia
     */
    'originalSequence'?: number;
    /**
     * 
     * @type {object}
     * @memberof LegacyMedia
     */
    'extraInfo'?: object;
}
/**
 * 
 * @export
 * @interface MaterialType
 */
export interface MaterialType {
    /**
     * product material type id
     * @type {number}
     * @memberof MaterialType
     */
    'materialTypeId'?: number;
    /**
     * product material type description
     * @type {string}
     * @memberof MaterialType
     */
    'materialTypeDesc'?: string;
}
/**
 * 
 * @export
 * @interface MaterialTypeResponse
 */
export interface MaterialTypeResponse {
    /**
     * list materialType
     * @type {Array<MaterialType>}
     * @memberof MaterialTypeResponse
     */
    'materialTypeList'?: Array<MaterialType>;
}
/**
 * 
 * @export
 * @interface MediaPlace
 */
export interface MediaPlace {
    /**
     * type of media
     * @type {string}
     * @memberof MediaPlace
     */
    'place'?: string;
    /**
     * order of priority of this media on that place
     * @type {number}
     * @memberof MediaPlace
     */
    'ordinal'?: number;
}
/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'internalMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'publicMessage'?: string;
}
/**
 * 
 * @export
 * @interface ModerateIAProductRequest
 */
export interface ModerateIAProductRequest {
    /**
     * 
     * @type {number}
     * @memberof ModerateIAProductRequest
     */
    'productId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ModerateIAProductRequest
     */
    'storeId'?: number;
}
/**
 * 
 * @export
 * @interface ModerationAcceptPayloadMessage
 */
export interface ModerationAcceptPayloadMessage {
    /**
     * 
     * @type {ImageData}
     * @memberof ModerationAcceptPayloadMessage
     */
    'coverImage'?: ImageData;
    /**
     * 
     * @type {ImageData}
     * @memberof ModerationAcceptPayloadMessage
     */
    'frontImage'?: ImageData;
    /**
     * 
     * @type {ImageData}
     * @memberof ModerationAcceptPayloadMessage
     */
    'backImage'?: ImageData;
}
/**
 * 
 * @export
 * @interface ModerationFlowRequest
 */
export interface ModerationFlowRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ModerationFlowRequest
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModerationFlowRequest
     */
    'defaultFlow'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof ModerationFlowRequest
     */
    'catalogIds'?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof ModerationFlowRequest
     */
    'viewBackisRequired'?: boolean;
    /**
     * 
     * @type {{ [key: string]: ModerationOperationConfig; }}
     * @memberof ModerationFlowRequest
     */
    'config'?: { [key: string]: ModerationOperationConfig; };
}
/**
 * 
 * @export
 * @interface ModerationFlowResponse
 */
export interface ModerationFlowResponse {
    /**
     * 
     * @type {string}
     * @memberof ModerationFlowResponse
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ModerationFlowResponse
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ModerationFlowResponse
     */
    'defaultFlow'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof ModerationFlowResponse
     */
    'catalogIds'?: Array<number>;
    /**
     * 
     * @type {{ [key: string]: ModerationOperationConfig; }}
     * @memberof ModerationFlowResponse
     */
    'config'?: { [key: string]: ModerationOperationConfig; };
}
/**
 * 
 * @export
 * @interface ModerationOperationConfig
 */
export interface ModerationOperationConfig {
    /**
     * 
     * @type {boolean}
     * @memberof ModerationOperationConfig
     */
    'visibleResult'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ModerationOperationConfig
     */
    'priority'?: number;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ModerationOperationConfig
     */
    'parameters'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface NextProductDto
 */
export interface NextProductDto {
    /**
     * 
     * @type {number}
     * @memberof NextProductDto
     */
    'catalogId'?: number;
    /**
     * 
     * @type {string}
     * @memberof NextProductDto
     */
    'sku'?: string;
    /**
     * 
     * @type {string}
     * @memberof NextProductDto
     */
    'catalogTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof NextProductDto
     */
    'catalogLongDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof NextProductDto
     */
    'shortDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof NextProductDto
     */
    'colorLabel'?: string;
    /**
     * 
     * @type {string}
     * @memberof NextProductDto
     */
    'catalogComposition'?: string;
    /**
     * 
     * @type {ProductImageItxDto}
     * @memberof NextProductDto
     */
    'frontImage'?: ProductImageItxDto;
    /**
     * 
     * @type {number}
     * @memberof NextProductDto
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof NextProductDto
     */
    'sellerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof NextProductDto
     */
    'categoryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof NextProductDto
     */
    'sizeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof NextProductDto
     */
    'color'?: number;
    /**
     * 
     * @type {string}
     * @memberof NextProductDto
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof NextProductDto
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof NextProductDto
     */
    'condition'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof NextProductDto
     */
    'termsAndConditions'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof NextProductDto
     */
    'yearOfPurchase'?: number;
    /**
     * 
     * @type {number}
     * @memberof NextProductDto
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof NextProductDto
     */
    'exponent'?: number;
    /**
     * 
     * @type {Array<ProductImageItxDto>}
     * @memberof NextProductDto
     */
    'images'?: Array<ProductImageItxDto>;
    /**
     * 
     * @type {number}
     * @memberof NextProductDto
     */
    'customerAddressId'?: number;
    /**
     * 
     * @type {string}
     * @memberof NextProductDto
     */
    'productState'?: NextProductDtoProductStateEnum;
    /**
     * 
     * @type {RejectReasonItxDto}
     * @memberof NextProductDto
     */
    'rejectReason'?: RejectReasonItxDto;
    /**
     * 
     * @type {string}
     * @memberof NextProductDto
     */
    'creationDate'?: string;
}

export const NextProductDtoProductStateEnum = {
    AmandaProcessing: 'AMANDA_PROCESSING',
    PendingReview: 'PENDING_REVIEW',
    InReview: 'IN_REVIEW',
    AmandaProcessingGrid: 'AMANDA_PROCESSING_GRID',
    Active: 'ACTIVE',
    Paused: 'PAUSED',
    PausedAmandaProcessing: 'PAUSED_AMANDA_PROCESSING',
    PausedPendingReview: 'PAUSED_PENDING_REVIEW',
    Sold: 'SOLD',
    Rejected: 'REJECTED',
    Deleted: 'DELETED',
    PendingEvaluationAi: 'PENDING_EVALUATION_AI',
    PausedPendingEvaluationAi: 'PAUSED_PENDING_EVALUATION_AI'
} as const;

export type NextProductDtoProductStateEnum = typeof NextProductDtoProductStateEnum[keyof typeof NextProductDtoProductStateEnum];

/**
 * 
 * @export
 * @interface OperationResult
 */
export interface OperationResult {
    /**
     * Number of successfully processed entities
     * @type {number}
     * @memberof OperationResult
     */
    'successCount': number;
    /**
     * Number of entities that could not be processed
     * @type {number}
     * @memberof OperationResult
     */
    'failureCount': number;
    /**
     * Descriptions of failures
     * @type {Array<string>}
     * @memberof OperationResult
     */
    'failureMessages': Array<string>;
    /**
     * Warnings
     * @type {Array<string>}
     * @memberof OperationResult
     */
    'warningMessages': Array<string>;
}
/**
 * 
 * @export
 * @interface OptionContentFilter
 */
export interface OptionContentFilter {
    /**
     * 
     * @type {string}
     * @memberof OptionContentFilter
     */
    'type': string;
    /**
     * list of search values
     * @type {Array<number>}
     * @memberof OptionContentFilter
     */
    'values'?: Array<number>;
}
/**
 * 
 * @export
 * @interface OptionContentFilters
 */
export interface OptionContentFilters {
    /**
     * 
     * @type {string}
     * @memberof OptionContentFilters
     */
    'type': string;
    /**
     * list of search values
     * @type {Array<number>}
     * @memberof OptionContentFilters
     */
    'values'?: Array<number>;
    /**
     * Product option type referred by this criterion
     * @type {string}
     * @memberof OptionContentFilters
     */
    'optionType'?: OptionContentFiltersOptionTypeEnum;
}

export const OptionContentFiltersOptionTypeEnum = {
    Color: 'COLOR',
    Size: 'SIZE',
    Condition: 'CONDITION'
} as const;

export type OptionContentFiltersOptionTypeEnum = typeof OptionContentFiltersOptionTypeEnum[keyof typeof OptionContentFiltersOptionTypeEnum];

/**
 * Option-based filter criterion
 * @export
 * @interface OptionGridFilterCriterion
 */
export interface OptionGridFilterCriterion extends GridFilterCriterion {
    /**
     * Ids of the entities accepted by this filter
     * @type {Array<number>}
     * @memberof OptionGridFilterCriterion
     */
    'values'?: Array<number>;
    /**
     * Product option type referred by this criterion
     * @type {string}
     * @memberof OptionGridFilterCriterion
     */
    'optionType'?: OptionGridFilterCriterionOptionTypeEnum;
}

export const OptionGridFilterCriterionOptionTypeEnum = {
    Color: 'COLOR',
    Size: 'SIZE',
    Condition: 'CONDITION'
} as const;

export type OptionGridFilterCriterionOptionTypeEnum = typeof OptionGridFilterCriterionOptionTypeEnum[keyof typeof OptionGridFilterCriterionOptionTypeEnum];

/**
 * 
 * @export
 * @interface OptionGridFilterCriterionAllOf
 */
export interface OptionGridFilterCriterionAllOf {
    /**
     * Ids of the entities accepted by this filter
     * @type {Array<number>}
     * @memberof OptionGridFilterCriterionAllOf
     */
    'values'?: Array<number>;
    /**
     * Product option type referred by this criterion
     * @type {string}
     * @memberof OptionGridFilterCriterionAllOf
     */
    'optionType'?: OptionGridFilterCriterionAllOfOptionTypeEnum;
}

export const OptionGridFilterCriterionAllOfOptionTypeEnum = {
    Color: 'COLOR',
    Size: 'SIZE',
    Condition: 'CONDITION'
} as const;

export type OptionGridFilterCriterionAllOfOptionTypeEnum = typeof OptionGridFilterCriterionAllOfOptionTypeEnum[keyof typeof OptionGridFilterCriterionAllOfOptionTypeEnum];

/**
 * 
 * @export
 * @interface PageMetadata
 */
export interface PageMetadata {
    /**
     * Number of items in current page.
     * @type {number}
     * @memberof PageMetadata
     */
    'items_count': number;
    /**
     * Number of items skipped.
     * @type {number}
     * @memberof PageMetadata
     */
    'items_start': number;
    /**
     * Number of the last item in current page.
     * @type {number}
     * @memberof PageMetadata
     */
    'items_finish': number;
    /**
     * Number of items in total (all pages).
     * @type {number}
     * @memberof PageMetadata
     */
    'items_total': number;
    /**
     * Timestamp (ISO Format) when request started.
     * @type {string}
     * @memberof PageMetadata
     */
    'requestTimestamp': string;
    /**
     * Timestamp (ISO Format) when request ended.
     * @type {string}
     * @memberof PageMetadata
     */
    'responseTimestamp': string;
}
/**
 * 
 * @export
 * @interface PageOfBlacklist
 */
export interface PageOfBlacklist {
    /**
     * 
     * @type {Array<Blacklist>}
     * @memberof PageOfBlacklist
     */
    'data': Array<Blacklist>;
    /**
     * 
     * @type {PageMetadata}
     * @memberof PageOfBlacklist
     */
    'metadata': PageMetadata;
}
/**
 * 
 * @export
 * @interface PageOfToken
 */
export interface PageOfToken {
    /**
     * 
     * @type {Array<Token>}
     * @memberof PageOfToken
     */
    'data': Array<Token>;
    /**
     * 
     * @type {PageMetadata}
     * @memberof PageOfToken
     */
    'metadata': PageMetadata;
}
/**
 * 
 * @export
 * @interface PageProductGroup
 */
export interface PageProductGroup {
    /**
     * 
     * @type {number}
     * @memberof PageProductGroup
     */
    'totalElements'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageProductGroup
     */
    'totalPages'?: number;
    /**
     * 
     * @type {PageableObject}
     * @memberof PageProductGroup
     */
    'pageable'?: PageableObject;
    /**
     * 
     * @type {boolean}
     * @memberof PageProductGroup
     */
    'first'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageProductGroup
     */
    'last'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PageProductGroup
     */
    'size'?: number;
    /**
     * 
     * @type {Array<Group>}
     * @memberof PageProductGroup
     */
    'content'?: Array<Group>;
    /**
     * 
     * @type {number}
     * @memberof PageProductGroup
     */
    'number'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageProductGroup
     */
    'sort'?: Sort;
    /**
     * 
     * @type {number}
     * @memberof PageProductGroup
     */
    'numberOfElements'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PageProductGroup
     */
    'empty'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof PageProductGroup
     */
    'productIds'?: Array<number>;
}
/**
 * 
 * @export
 * @interface PageableObject
 */
export interface PageableObject {
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    'pageSize'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    'pageNumber'?: number;
    /**
     * 
     * @type {number}
     * @memberof PageableObject
     */
    'offset'?: number;
    /**
     * 
     * @type {Sort}
     * @memberof PageableObject
     */
    'sort'?: Sort;
    /**
     * 
     * @type {boolean}
     * @memberof PageableObject
     */
    'paged'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PageableObject
     */
    'unpaged'?: boolean;
}
/**
 * 
 * @export
 * @interface PaymentEvent
 */
export interface PaymentEvent {
    /**
     * 
     * @type {string}
     * @memberof PaymentEvent
     */
    'trackingDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentEvent
     */
    'trackingId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentEvent
     */
    'event'?: string;
}
/**
 * 
 * @export
 * @interface PaymentIntent
 */
export interface PaymentIntent {
    /**
     * 
     * @type {string}
     * @memberof PaymentIntent
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentIntent
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentIntent
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentIntent
     */
    'due_date'?: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentIntent
     */
    'totalIntents'?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentIntent
     */
    'numberOfRetries'?: number;
    /**
     * 
     * @type {Array<PaymentEvent>}
     * @memberof PaymentIntent
     */
    'events'?: Array<PaymentEvent>;
}
/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'catalogId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'sku'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'catalogTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'catalogLongDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'shortDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'colorLabel'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'catalogComposition'?: string;
    /**
     * 
     * @type {ProductImageItxDto}
     * @memberof Product
     */
    'frontImage'?: ProductImageItxDto;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'sellerId'?: number;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'categoryId'?: number;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'sizeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'color'?: number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'condition'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Product
     */
    'termsAndConditions'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'yearOfPurchase'?: number;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'exponent'?: number;
    /**
     * 
     * @type {Array<ProductImageItxDto>}
     * @memberof Product
     */
    'images'?: Array<ProductImageItxDto>;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    'customerAddressId'?: number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'productState'?: ProductProductStateEnum;
    /**
     * 
     * @type {Array<RejectReasonItxDto>}
     * @memberof Product
     */
    'rejectReason'?: Array<RejectReasonItxDto>;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    'creationDate'?: string;
}

export const ProductProductStateEnum = {
    AmandaProcessing: 'AMANDA_PROCESSING',
    PendingReview: 'PENDING_REVIEW',
    InReview: 'IN_REVIEW',
    AmandaProcessingGrid: 'AMANDA_PROCESSING_GRID',
    Active: 'ACTIVE',
    Paused: 'PAUSED',
    PausedAmandaProcessing: 'PAUSED_AMANDA_PROCESSING',
    PausedPendingReview: 'PAUSED_PENDING_REVIEW',
    Sold: 'SOLD',
    Rejected: 'REJECTED',
    Deleted: 'DELETED',
    PendingEvaluationAi: 'PENDING_EVALUATION_AI',
    PausedPendingEvaluationAi: 'PAUSED_PENDING_EVALUATION_AI'
} as const;

export type ProductProductStateEnum = typeof ProductProductStateEnum[keyof typeof ProductProductStateEnum];

/**
 * 
 * @export
 * @interface ProductConditionType
 */
export interface ProductConditionType {
    /**
     * product condition type id
     * @type {number}
     * @memberof ProductConditionType
     */
    'productConditionTypeId'?: number;
    /**
     * product condition type description
     * @type {string}
     * @memberof ProductConditionType
     */
    'productConditionTypeDesc'?: string;
}
/**
 * 
 * @export
 * @interface ProductConditionTypeResponse
 */
export interface ProductConditionTypeResponse {
    /**
     * list productConditionType
     * @type {Array<ProductConditionType>}
     * @memberof ProductConditionTypeResponse
     */
    'productConditionTypeList'?: Array<ProductConditionType>;
}
/**
 * 
 * @export
 * @interface ProductFilter
 */
export interface ProductFilter {
    /**
     * Product group Id
     * @type {number}
     * @memberof ProductFilter
     */
    'productGroupId'?: number;
}
/**
 * 
 * @export
 * @interface ProductFixType
 */
export interface ProductFixType {
    /**
     * product type id
     * @type {number}
     * @memberof ProductFixType
     */
    'productTypeId'?: number;
    /**
     * product type description
     * @type {string}
     * @memberof ProductFixType
     */
    'productTypeDesc'?: string;
    /**
     * 
     * @type {Array<FixType>}
     * @memberof ProductFixType
     */
    'fixList'?: Array<FixType>;
}
/**
 * 
 * @export
 * @interface ProductFixTypeResponse
 */
export interface ProductFixTypeResponse {
    /**
     * list productFixType
     * @type {Array<ProductFixType>}
     * @memberof ProductFixTypeResponse
     */
    'productFixTypeList'?: Array<ProductFixType>;
}
/**
 * 
 * @export
 * @interface ProductGroup
 */
export interface ProductGroup {
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductGroup
     */
    'removedProducts'?: Array<number>;
}
/**
 * 
 * @export
 * @interface ProductImageItxDto
 */
export interface ProductImageItxDto {
    /**
     * 
     * @type {string}
     * @memberof ProductImageItxDto
     */
    'assetId'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductImageItxDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductImageItxDto
     */
    'amandaId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductImageItxDto
     */
    'deliveryUrl'?: string;
}
/**
 * 
 * @export
 * @interface ProductOptionValueDescriptionDto
 */
export interface ProductOptionValueDescriptionDto {
    /**
     * ISO 639-1 language code
     * @type {string}
     * @memberof ProductOptionValueDescriptionDto
     */
    'languageCode': string;
    /**
     * Entity name
     * @type {string}
     * @memberof ProductOptionValueDescriptionDto
     */
    'name'?: string;
    /**
     * Entity title
     * @type {string}
     * @memberof ProductOptionValueDescriptionDto
     */
    'title'?: string;
    /**
     * Entity description
     * @type {string}
     * @memberof ProductOptionValueDescriptionDto
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface ProductOptionValueDto
 */
export interface ProductOptionValueDto {
    /**
     * 
     * @type {number}
     * @memberof ProductOptionValueDto
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductOptionValueDto
     */
    'productOptionValueSortOrder'?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductOptionValueDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ProductOptionValueDto
     */
    'mappings'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductOptionValueDto
     */
    'extra'?: string;
    /**
     * 
     * @type {Array<ProductOptionValueDescriptionDto>}
     * @memberof ProductOptionValueDto
     */
    'descriptions'?: Array<ProductOptionValueDescriptionDto>;
}
/**
 * 
 * @export
 * @interface ProductOut
 */
export interface ProductOut {
    /**
     * 
     * @type {string}
     * @memberof ProductOut
     */
    'gridId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductOut
     */
    'outOfDate'?: boolean;
}
/**
 * 
 * @export
 * @interface ProductPriceDto
 */
export interface ProductPriceDto {
    /**
     * 
     * @type {string}
     * @memberof ProductPriceDto
     */
    'currency'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDto
     */
    'value'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPriceDto
     */
    'exponent'?: number;
}
/**
 * 
 * @export
 * @interface ProductPrices
 */
export interface ProductPrices {
    /**
     * 
     * @type {ProductPriceDto}
     * @memberof ProductPrices
     */
    'min'?: ProductPriceDto;
    /**
     * 
     * @type {ProductPriceDto}
     * @memberof ProductPrices
     */
    'max'?: ProductPriceDto;
}
/**
 * 
 * @export
 * @interface ProductReviewerStats
 */
export interface ProductReviewerStats {
    /**
     * 
     * @type {number}
     * @memberof ProductReviewerStats
     */
    'productsPendingReview': number;
    /**
     * 
     * @type {number}
     * @memberof ProductReviewerStats
     */
    'productsReviewedSoFar': number;
}
/**
 * 
 * @export
 * @interface ProductSize
 */
export interface ProductSize {
    /**
     * 
     * @type {number}
     * @memberof ProductSize
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductSize
     */
    'count'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductSize
     */
    'isHit'?: boolean;
}
/**
 * 
 * @export
 * @interface ReasonItxDto
 */
export interface ReasonItxDto {
    /**
     * 
     * @type {number}
     * @memberof ReasonItxDto
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReasonItxDto
     */
    'code'?: string;
}
/**
 * 
 * @export
 * @interface RejectReasonDescriptionDto
 */
export interface RejectReasonDescriptionDto {
    /**
     * ISO 639-1 language code
     * @type {string}
     * @memberof RejectReasonDescriptionDto
     */
    'languageCode': string;
    /**
     * Entity name
     * @type {string}
     * @memberof RejectReasonDescriptionDto
     */
    'name'?: string;
    /**
     * Entity title
     * @type {string}
     * @memberof RejectReasonDescriptionDto
     */
    'title'?: string;
    /**
     * Entity description
     * @type {string}
     * @memberof RejectReasonDescriptionDto
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface RejectReasonItxDto
 */
export interface RejectReasonItxDto {
    /**
     * 
     * @type {string}
     * @memberof RejectReasonItxDto
     */
    'rejectReasonCode': string;
    /**
     * 
     * @type {Array<RejectReasonDescriptionDto>}
     * @memberof RejectReasonItxDto
     */
    'descriptions': Array<RejectReasonDescriptionDto>;
    /**
     * 
     * @type {boolean}
     * @memberof RejectReasonItxDto
     */
    'disabled'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RejectReasonItxDto
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface RejectReasonRequest
 */
export interface RejectReasonRequest {
    /**
     * 
     * @type {string}
     * @memberof RejectReasonRequest
     */
    'rejectReasonCode'?: RejectReasonRequestRejectReasonCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof RejectReasonRequest
     */
    'realRejectReasonCode'?: RejectReasonRequestRealRejectReasonCodeEnum;
}

export const RejectReasonRequestRejectReasonCodeEnum = {
    Blurry: 'BLURRY',
    ImageContent: 'IMAGE_CONTENT',
    Rotation: 'ROTATION',
    Views: 'VIEWS',
    Duplicated: 'DUPLICATED',
    TextContent: 'TEXT_CONTENT',
    Image: 'IMAGE',
    FrontalImageNotFound: 'FRONTAL_IMAGE_NOT_FOUND',
    BackImageNotFound: 'BACK_IMAGE_NOT_FOUND',
    NotCentered: 'NOT_CENTERED'
} as const;

export type RejectReasonRequestRejectReasonCodeEnum = typeof RejectReasonRequestRejectReasonCodeEnum[keyof typeof RejectReasonRequestRejectReasonCodeEnum];
export const RejectReasonRequestRealRejectReasonCodeEnum = {
    BackViewArticle: 'BACK_VIEW_ARTICLE',
    BadImageQuality: 'BAD_IMAGE_QUALITY',
    BrandImage: 'BRAND_IMAGE',
    CopyrightedImages: 'COPYRIGHTED_IMAGES',
    DuplicatedListing: 'DUPLICATED_LISTING',
    IncompleteDescription: 'INCOMPLETE_DESCRIPTION',
    IncorrectImages: 'INCORRECT_IMAGES',
    InvalidDescription: 'INVALID_DESCRIPTION',
    MoreThanOneArticle: 'MORE_THAN_ONE_ARTICLE',
    NoRealImagesIncluded: 'NO_REAL_IMAGES_INCLUDED',
    NotAllViewsIncluded: 'NOT_ALL_VIEWS_INCLUDED',
    NotEligibleForResell: 'NOT_ELIGIBLE_FOR_RESELL',
    NotFullyCaptured: 'NOT_FULLY_CAPTURED'
} as const;

export type RejectReasonRequestRealRejectReasonCodeEnum = typeof RejectReasonRequestRealRejectReasonCodeEnum[keyof typeof RejectReasonRequestRealRejectReasonCodeEnum];

/**
 * 
 * @export
 * @interface RepairCurrencyConversionRate
 */
export interface RepairCurrencyConversionRate {
    /**
     * 
     * @type {string}
     * @memberof RepairCurrencyConversionRate
     */
    'from'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairCurrencyConversionRate
     */
    'to'?: string;
    /**
     * 
     * @type {number}
     * @memberof RepairCurrencyConversionRate
     */
    'rate'?: number;
}
/**
 * 
 * @export
 * @interface RepairFormatsLocale
 */
export interface RepairFormatsLocale {
    /**
     * 
     * @type {RepairLanguageNumberFormat}
     * @memberof RepairFormatsLocale
     */
    'number'?: RepairLanguageNumberFormat;
    /**
     * 
     * @type {RepairLanguageDateFormat}
     * @memberof RepairFormatsLocale
     */
    'date'?: RepairLanguageDateFormat;
}
/**
 * 
 * @export
 * @interface RepairItem
 */
export interface RepairItem {
    /**
     * 
     * @type {number}
     * @memberof RepairItem
     */
    'id'?: number;
    /**
     * 
     * @type {RepairItemProductType}
     * @memberof RepairItem
     */
    'productType'?: RepairItemProductType;
    /**
     * 
     * @type {RepairItemProductType}
     * @memberof RepairItem
     */
    'condition'?: RepairItemProductType;
    /**
     * 
     * @type {RepairItemProductType}
     * @memberof RepairItem
     */
    'color'?: RepairItemProductType;
    /**
     * 
     * @type {string}
     * @memberof RepairItem
     */
    'material'?: string;
    /**
     * 
     * @type {Array<Reparation>}
     * @memberof RepairItem
     */
    'reparations'?: Array<Reparation>;
}
/**
 * 
 * @export
 * @interface RepairItemProductType
 */
export interface RepairItemProductType {
    /**
     * 
     * @type {number}
     * @memberof RepairItemProductType
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof RepairItemProductType
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface RepairItemRequest
 */
export interface RepairItemRequest {
    /**
     * 
     * @type {number}
     * @memberof RepairItemRequest
     */
    'productTypeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairItemRequest
     */
    'conditionId'?: number;
    /**
     * 
     * @type {number}
     * @memberof RepairItemRequest
     */
    'colorId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RepairItemRequest
     */
    'material'?: string;
    /**
     * 
     * @type {Array<ReparationRequest>}
     * @memberof RepairItemRequest
     */
    'reparations'?: Array<ReparationRequest>;
}
/**
 * 
 * @export
 * @interface RepairLanguage
 */
export interface RepairLanguage {
    /**
     * 
     * @type {number}
     * @memberof RepairLanguage
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof RepairLanguage
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairLanguage
     */
    'locale'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairLanguage
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairLanguage
     */
    'countryName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RepairLanguage
     */
    'isSeoIrrelevant'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RepairLanguage
     */
    'isSeoProductIrrelevant'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RepairLanguage
     */
    'direction'?: string;
    /**
     * 
     * @type {RepairFormatsLocale}
     * @memberof RepairLanguage
     */
    'formats'?: RepairFormatsLocale;
}
/**
 * 
 * @export
 * @interface RepairLanguageDateFormat
 */
export interface RepairLanguageDateFormat {
    /**
     * 
     * @type {string}
     * @memberof RepairLanguageDateFormat
     */
    'shortDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairLanguageDateFormat
     */
    'longDate'?: string;
}
/**
 * 
 * @export
 * @interface RepairLanguageNumberFormat
 */
export interface RepairLanguageNumberFormat {
    /**
     * 
     * @type {string}
     * @memberof RepairLanguageNumberFormat
     */
    'decimalSeparator'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairLanguageNumberFormat
     */
    'thousandsSeparator'?: string;
}
/**
 * 
 * @export
 * @interface RepairLocaleConfiguration
 */
export interface RepairLocaleConfiguration {
    /**
     * 
     * @type {string}
     * @memberof RepairLocaleConfiguration
     */
    'defaultCurrency'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairLocaleConfiguration
     */
    'defaultLocale'?: string;
    /**
     * 
     * @type {Array<RepairStoreLocale>}
     * @memberof RepairLocaleConfiguration
     */
    'availableLocales'?: Array<RepairStoreLocale>;
    /**
     * 
     * @type {Array<RepairStoreCurrency>}
     * @memberof RepairLocaleConfiguration
     */
    'availableCurrencies'?: Array<RepairStoreCurrency>;
}
/**
 * 
 * @export
 * @interface RepairOnline
 */
export interface RepairOnline {
    /**
     * 
     * @type {number}
     * @memberof RepairOnline
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof RepairOnline
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairOnline
     */
    'surname'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairOnline
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairOnline
     */
    'phone'?: string;
    /**
     * 
     * @type {Address}
     * @memberof RepairOnline
     */
    'addressReceive'?: Address;
    /**
     * 
     * @type {Address}
     * @memberof RepairOnline
     */
    'addressSend'?: Address;
    /**
     * 
     * @type {boolean}
     * @memberof RepairOnline
     */
    'termsAndConditions'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RepairOnline
     */
    'privacyPolicy'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RepairOnline
     */
    'status'?: RepairOnlineStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof RepairOnline
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairOnline
     */
    'updatedDate'?: string;
    /**
     * 
     * @type {PaymentIntent}
     * @memberof RepairOnline
     */
    'paymentIntent'?: PaymentIntent;
    /**
     * 
     * @type {Array<RepairItem>}
     * @memberof RepairOnline
     */
    'items'?: Array<RepairItem>;
    /**
     * 
     * @type {Array<TrackingEvent>}
     * @memberof RepairOnline
     */
    'tracking_events_send'?: Array<TrackingEvent>;
    /**
     * 
     * @type {Array<TrackingEvent>}
     * @memberof RepairOnline
     */
    'tracking_events_received'?: Array<TrackingEvent>;
    /**
     * 
     * @type {ShippingCost}
     * @memberof RepairOnline
     */
    'shippingCost'?: ShippingCost;
    /**
     * 
     * @type {string}
     * @memberof RepairOnline
     */
    'sst'?: string;
}

export const RepairOnlineStatusEnum = {
    Created: 'CREATED',
    PaymentPending: 'PAYMENT_PENDING',
    PaymentError: 'PAYMENT_ERROR',
    PaymentProccess: 'PAYMENT_PROCCESS',
    PaymentSucces: 'PAYMENT_SUCCES',
    ShippingPending: 'SHIPPING_PENDING',
    OnTransit: 'ON_TRANSIT',
    ShippingError: 'SHIPPING_ERROR',
    PendingReview: 'PENDING_REVIEW',
    Accepted: 'ACCEPTED',
    Canceled: 'CANCELED',
    FinishedRepair: 'FINISHED_REPAIR',
    FinishedRepairError: 'FINISHED_REPAIR_ERROR',
    ShippingPendingClient: 'SHIPPING_PENDING_CLIENT',
    ShippingErrorClient: 'SHIPPING_ERROR_CLIENT',
    OnTransitClient: 'ON_TRANSIT_CLIENT',
    Delivered: 'DELIVERED',
    Finish: 'FINISH',
    MqError: 'MQ_ERROR'
} as const;

export type RepairOnlineStatusEnum = typeof RepairOnlineStatusEnum[keyof typeof RepairOnlineStatusEnum];

/**
 * 
 * @export
 * @interface RepairOnlinePaymentRequest
 */
export interface RepairOnlinePaymentRequest {
    /**
     * 
     * @type {string}
     * @memberof RepairOnlinePaymentRequest
     */
    'transactionId'?: string;
    /**
     * 
     * @type {number}
     * @memberof RepairOnlinePaymentRequest
     */
    'totalPrice'?: number;
}
/**
 * 
 * @export
 * @interface RepairOnlineRequest
 */
export interface RepairOnlineRequest {
    /**
     * 
     * @type {string}
     * @memberof RepairOnlineRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairOnlineRequest
     */
    'surname'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairOnlineRequest
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairOnlineRequest
     */
    'phone'?: string;
    /**
     * 
     * @type {AddressRequest}
     * @memberof RepairOnlineRequest
     */
    'addressReceive'?: AddressRequest;
    /**
     * 
     * @type {boolean}
     * @memberof RepairOnlineRequest
     */
    'termsAndConditions'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RepairOnlineRequest
     */
    'privacyPolicy'?: boolean;
    /**
     * 
     * @type {Array<RepairItemRequest>}
     * @memberof RepairOnlineRequest
     */
    'items'?: Array<RepairItemRequest>;
    /**
     * 
     * @type {number}
     * @memberof RepairOnlineRequest
     */
    'shippingCostId'?: number;
}
/**
 * 
 * @export
 * @interface RepairStoreCurrency
 */
export interface RepairStoreCurrency {
    /**
     * 
     * @type {string}
     * @memberof RepairStoreCurrency
     */
    'currencyCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairStoreCurrency
     */
    'currencySymbol'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairStoreCurrency
     */
    'currencyFormat'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairStoreCurrency
     */
    'currencyDecimals'?: string;
    /**
     * 
     * @type {Array<RepairCurrencyConversionRate>}
     * @memberof RepairStoreCurrency
     */
    'conversionRates'?: Array<RepairCurrencyConversionRate>;
}
/**
 * 
 * @export
 * @interface RepairStoreLocale
 */
export interface RepairStoreLocale {
    /**
     * 
     * @type {string}
     * @memberof RepairStoreLocale
     */
    'codeLocale'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairStoreLocale
     */
    'isBankBicMandatory'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairStoreLocale
     */
    'isBankInnMandatory'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairStoreLocale
     */
    'isBankSwift'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairStoreLocale
     */
    'isCompoundName'?: string;
    /**
     * 
     * @type {string}
     * @memberof RepairStoreLocale
     */
    'isLastNameFirst'?: string;
}
/**
 * 
 * @export
 * @interface Reparation
 */
export interface Reparation {
    /**
     * 
     * @type {ReparationReparationType}
     * @memberof Reparation
     */
    'reparation_type'?: ReparationReparationType;
    /**
     * 
     * @type {string}
     * @memberof Reparation
     */
    'description'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Reparation
     */
    'images'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ReparationReparationType
 */
export interface ReparationReparationType {
    /**
     * 
     * @type {number}
     * @memberof ReparationReparationType
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReparationReparationType
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReparationReparationType
     */
    'longDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReparationReparationType
     */
    'pmocacota'?: string;
    /**
     * 
     * @type {ReparationReparationTypePrices}
     * @memberof ReparationReparationType
     */
    'prices'?: ReparationReparationTypePrices;
}
/**
 * 
 * @export
 * @interface ReparationReparationTypePrices
 */
export interface ReparationReparationTypePrices {
    /**
     * 
     * @type {number}
     * @memberof ReparationReparationTypePrices
     */
    'price'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReparationReparationTypePrices
     */
    'subsidizedPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReparationReparationTypePrices
     */
    'percent'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReparationReparationTypePrices
     */
    'currency'?: string;
}
/**
 * 
 * @export
 * @interface ReparationRequest
 */
export interface ReparationRequest {
    /**
     * 
     * @type {number}
     * @memberof ReparationRequest
     */
    'reparationTypeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReparationRequest
     */
    'description'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReparationRequest
     */
    'images'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ResellBackofficeUser
 */
export interface ResellBackofficeUser {
    /**
     * 
     * @type {string}
     * @memberof ResellBackofficeUser
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResellBackofficeUser
     */
    'login'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResellBackofficeUser
     */
    'mail'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResellBackofficeUser
     */
    'roles'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResellBackofficeUser
     */
    'permissions'?: Array<string>;
    /**
     * 
     * @type {Array<UserAttributes>}
     * @memberof ResellBackofficeUser
     */
    'attributes'?: Array<UserAttributes>;
}
/**
 * 
 * @export
 * @interface RetouchDto
 */
export interface RetouchDto {
    /**
     * 
     * @type {number}
     * @memberof RetouchDto
     */
    'productId'?: number;
    /**
     * 
     * @type {string}
     * @memberof RetouchDto
     */
    'marketIsoCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetouchDto
     */
    'assetId'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetouchDto
     */
    'deliveryUrl'?: string;
}
/**
 * 
 * @export
 * @interface SearchContentFilter
 */
export interface SearchContentFilter {
    /**
     * 
     * @type {string}
     * @memberof SearchContentFilter
     */
    'type': string;
    /**
     * List of the entire definition of search type filters
     * @type {Array<SearchesFilter>}
     * @memberof SearchContentFilter
     */
    'values'?: Array<SearchesFilter>;
}
/**
 * 
 * @export
 * @interface SearchContentFilters
 */
export interface SearchContentFilters {
    /**
     * 
     * @type {string}
     * @memberof SearchContentFilters
     */
    'type': string;
    /**
     * Type of operation
     * @type {string}
     * @memberof SearchContentFilters
     */
    'operation'?: string;
    /**
     * Search engine end
     * @type {string}
     * @memberof SearchContentFilters
     */
    'term'?: string;
}
/**
 * 
 * @export
 * @interface SearchCriteria
 */
export interface SearchCriteria {
    /**
     * 
     * @type {string}
     * @memberof SearchCriteria
     */
    'operation'?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchCriteria
     */
    'term'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof SearchCriteria
     */
    'foundProducts'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof SearchCriteria
     */
    'hash'?: string;
}
/**
 * IA Search-based filter criterion
 * @export
 * @interface SearchGridFilterCriterion
 */
export interface SearchGridFilterCriterion extends GridFilterCriterion {
    /**
     * Search term
     * @type {string}
     * @memberof SearchGridFilterCriterion
     */
    'searchTerm': string;
    /**
     * Search operation type
     * @type {string}
     * @memberof SearchGridFilterCriterion
     */
    'searchOperation': SearchGridFilterCriterionSearchOperationEnum;
    /**
     * Ids of the searched products
     * @type {Array<number>}
     * @memberof SearchGridFilterCriterion
     */
    'searchedProductGroups'?: Array<number>;
    /**
     * Hash of the searched products
     * @type {string}
     * @memberof SearchGridFilterCriterion
     */
    'searchedProductGroupsHash'?: string;
}

export const SearchGridFilterCriterionSearchOperationEnum = {
    Include: 'INCLUDE',
    Exclude: 'EXCLUDE',
    ExcludeManual: 'EXCLUDE_MANUAL'
} as const;

export type SearchGridFilterCriterionSearchOperationEnum = typeof SearchGridFilterCriterionSearchOperationEnum[keyof typeof SearchGridFilterCriterionSearchOperationEnum];

/**
 * 
 * @export
 * @interface SearchGridFilterCriterionAllOf
 */
export interface SearchGridFilterCriterionAllOf {
    /**
     * Search term
     * @type {string}
     * @memberof SearchGridFilterCriterionAllOf
     */
    'searchTerm': string;
    /**
     * Search operation type
     * @type {string}
     * @memberof SearchGridFilterCriterionAllOf
     */
    'searchOperation': SearchGridFilterCriterionAllOfSearchOperationEnum;
    /**
     * Ids of the searched products
     * @type {Array<number>}
     * @memberof SearchGridFilterCriterionAllOf
     */
    'searchedProductGroups'?: Array<number>;
    /**
     * Hash of the searched products
     * @type {string}
     * @memberof SearchGridFilterCriterionAllOf
     */
    'searchedProductGroupsHash'?: string;
}

export const SearchGridFilterCriterionAllOfSearchOperationEnum = {
    Include: 'INCLUDE',
    Exclude: 'EXCLUDE',
    ExcludeManual: 'EXCLUDE_MANUAL'
} as const;

export type SearchGridFilterCriterionAllOfSearchOperationEnum = typeof SearchGridFilterCriterionAllOfSearchOperationEnum[keyof typeof SearchGridFilterCriterionAllOfSearchOperationEnum];

/**
 * 
 * @export
 * @interface SearchProductCriteria
 */
export interface SearchProductCriteria {
    /**
     * 
     * @type {number}
     * @memberof SearchProductCriteria
     */
    'universeId'?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchProductCriteria
     */
    'storeId'?: number;
    /**
     * 
     * @type {FilterDefinitionRequest}
     * @memberof SearchProductCriteria
     */
    'filterDefinition'?: FilterDefinitionRequest;
}
/**
 * 
 * @export
 * @interface SearchesFilter
 */
export interface SearchesFilter {
    /**
     * Type of operation
     * @type {string}
     * @memberof SearchesFilter
     */
    'operation'?: string;
    /**
     * Search engine end
     * @type {string}
     * @memberof SearchesFilter
     */
    'term'?: string;
    /**
     * Ids of the found products
     * @type {Array<number>}
     * @memberof SearchesFilter
     */
    'foundProducts'?: Array<number>;
}
/**
 * 
 * @export
 * @interface ShippingCost
 */
export interface ShippingCost {
    /**
     * 
     * @type {string}
     * @memberof ShippingCost
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingCost
     */
    'type'?: ShippingCostTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ShippingCost
     */
    'entityType'?: ShippingCostEntityTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ShippingCost
     */
    'storeId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ShippingCost
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingCost
     */
    'label'?: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingCost
     */
    'conditions'?: string;
    /**
     * 
     * @type {Array<ShippingCostPrice>}
     * @memberof ShippingCost
     */
    'prices'?: Array<ShippingCostPrice>;
}

export const ShippingCostTypeEnum = {
    Drop: 'STANDARD_DROP',
    Home: 'STANDARD_HOME'
} as const;

export type ShippingCostTypeEnum = typeof ShippingCostTypeEnum[keyof typeof ShippingCostTypeEnum];
export const ShippingCostEntityTypeEnum = {
    Repair: 'REPAIR',
    Donate: 'DONATE'
} as const;

export type ShippingCostEntityTypeEnum = typeof ShippingCostEntityTypeEnum[keyof typeof ShippingCostEntityTypeEnum];

/**
 * 
 * @export
 * @interface ShippingCostPrice
 */
export interface ShippingCostPrice {
    /**
     * 
     * @type {string}
     * @memberof ShippingCostPrice
     */
    'type'?: ShippingCostPriceTypeEnum;
    /**
     * 
     * @type {Ammount}
     * @memberof ShippingCostPrice
     */
    'primaryPrice'?: Ammount;
    /**
     * 
     * @type {number}
     * @memberof ShippingCostPrice
     */
    'primaryPriceHumanFirendly'?: number;
    /**
     * 
     * @type {Ammount}
     * @memberof ShippingCostPrice
     */
    'secondaryPrice'?: Ammount;
    /**
     * 
     * @type {number}
     * @memberof ShippingCostPrice
     */
    'secondaryPriceHumanFirendly'?: number;
}

export const ShippingCostPriceTypeEnum = {
    Price: 'PRICE',
    Tax: 'TAX'
} as const;

export type ShippingCostPriceTypeEnum = typeof ShippingCostPriceTypeEnum[keyof typeof ShippingCostPriceTypeEnum];

/**
 * 
 * @export
 * @interface Sort
 */
export interface Sort {
    /**
     * 
     * @type {boolean}
     * @memberof Sort
     */
    'sorted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Sort
     */
    'empty'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Sort
     */
    'unsorted'?: boolean;
}
/**
 * 
 * @export
 * @interface State
 */
export interface State {
    /**
     * 
     * @type {string}
     * @memberof State
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof State
     */
    'code'?: string;
}
/**
 * 
 * @export
 * @interface StoreConfigurationPublic
 */
export interface StoreConfigurationPublic {
    /**
     * 
     * @type {string}
     * @memberof StoreConfigurationPublic
     */
    'id'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StoreConfigurationPublic
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {StoreLanguages}
     * @memberof StoreConfigurationPublic
     */
    'languages'?: StoreLanguages;
    /**
     * 
     * @type {RepairLocaleConfiguration}
     * @memberof StoreConfigurationPublic
     */
    'locale'?: RepairLocaleConfiguration;
    /**
     * 
     * @type {string}
     * @memberof StoreConfigurationPublic
     */
    'marketIso'?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreConfigurationPublic
     */
    'collaboratingEntity'?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreConfigurationPublic
     */
    'privacyPolicy'?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreConfigurationPublic
     */
    'termsAndConditions'?: string;
    /**
     * 
     * @type {string}
     * @memberof StoreConfigurationPublic
     */
    'paymentType'?: StoreConfigurationPublicPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof StoreConfigurationPublic
     */
    'paypalClientId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof StoreConfigurationPublic
     */
    'googleValidationEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StoreConfigurationPublic
     */
    'paypalIdSubstitution'?: boolean;
}

export const StoreConfigurationPublicPaymentTypeEnum = {
    Hpp: 'HPP',
    Paypal: 'PAYPAL'
} as const;

export type StoreConfigurationPublicPaymentTypeEnum = typeof StoreConfigurationPublicPaymentTypeEnum[keyof typeof StoreConfigurationPublicPaymentTypeEnum];

/**
 * 
 * @export
 * @interface StoreInfo
 */
export interface StoreInfo {
    /**
     * 
     * @type {number}
     * @memberof StoreInfo
     */
    'itxId': number;
    /**
     * 
     * @type {string}
     * @memberof StoreInfo
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof StoreInfo
     */
    'defaultLanguage': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof StoreInfo
     */
    'languages': Array<string>;
}
/**
 * 
 * @export
 * @interface StoreLanguages
 */
export interface StoreLanguages {
    /**
     * 
     * @type {string}
     * @memberof StoreLanguages
     */
    'default'?: string;
    /**
     * 
     * @type {Array<RepairLanguage>}
     * @memberof StoreLanguages
     */
    'availableLanguages'?: Array<RepairLanguage>;
}
/**
 * 
 * @export
 * @interface Token
 */
export interface Token {
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    'value': string;
    /**
     * True if this token is case-sensitive.
     * @type {boolean}
     * @memberof Token
     */
    'caseSensitive'?: boolean;
    /**
     * True if this token must match full word.
     * @type {boolean}
     * @memberof Token
     */
    'whole'?: boolean;
    /**
     * True if the token generates a blocking match.
     * @type {boolean}
     * @memberof Token
     */
    'blocking'?: boolean;
    /**
     * Locales with modifier
     * @type {Set<string>}
     * @memberof Token
     */
    'locales'?: Set<string>;
}
/**
 * Token that match with the related text by blakclist.
 * @export
 * @interface TokenCheckMatch
 */
export interface TokenCheckMatch {
    /**
     * Blacklist ID
     * @type {string}
     * @memberof TokenCheckMatch
     */
    'blacklistId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenCheckMatch
     */
    'token'?: string;
    /**
     * True if the token generates a blocking match.
     * @type {boolean}
     * @memberof TokenCheckMatch
     */
    'blocking'?: boolean;
}
/**
 * 
 * @export
 * @interface TrackingEvent
 */
export interface TrackingEvent {
    /**
     * 
     * @type {string}
     * @memberof TrackingEvent
     */
    'trackingDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingEvent
     */
    'trackingId'?: string;
    /**
     * 
     * @type {string}
     * @memberof TrackingEvent
     */
    'event'?: string;
}
/**
 * 
 * @export
 * @interface TranslateInput
 */
export interface TranslateInput {
    /**
     * the output text locale.
     * @type {string}
     * @memberof TranslateInput
     */
    'targetLocale'?: string;
    /**
     * the text to translate.
     * @type {string}
     * @memberof TranslateInput
     */
    'text'?: string;
}
/**
 * 
 * @export
 * @interface TranslateInputPublic
 */
export interface TranslateInputPublic {
    /**
     * the output text locale.
     * @type {string}
     * @memberof TranslateInputPublic
     */
    'targetLocale'?: string;
}
/**
 * 
 * @export
 * @interface TranslateOutput
 */
export interface TranslateOutput {
    /**
     * the text translated.
     * @type {string}
     * @memberof TranslateOutput
     */
    'translatedText'?: string;
}
/**
 * 
 * @export
 * @interface TranslateOutputPublic
 */
export interface TranslateOutputPublic {
    /**
     * the title translated.
     * @type {string}
     * @memberof TranslateOutputPublic
     */
    'title'?: string;
    /**
     * the description translated.
     * @type {string}
     * @memberof TranslateOutputPublic
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface Universe
 */
export interface Universe {
    /**
     * Universe Id
     * @type {number}
     * @memberof Universe
     */
    'id'?: number;
    /**
     * Universe description in all supported languages.
     * @type {Array<UniverseDescription>}
     * @memberof Universe
     */
    'descriptions': Array<UniverseDescription>;
    /**
     * Categories associated to universe (ids).
     * @type {Set<number>}
     * @memberof Universe
     */
    'categories'?: Set<number>;
    /**
     * Grid visibility on main menu
     * @type {boolean}
     * @memberof Universe
     */
    'visible'?: boolean;
    /**
     * Is universe default
     * @type {boolean}
     * @memberof Universe
     */
    'default'?: boolean;
}
/**
 * Universe description in all supported languages.
 * @export
 * @interface UniverseDescription
 */
export interface UniverseDescription {
    /**
     * ISO 639-1 language code
     * @type {string}
     * @memberof UniverseDescription
     */
    'languageCode': string;
    /**
     * Entity name
     * @type {string}
     * @memberof UniverseDescription
     */
    'name'?: string;
    /**
     * Entity title
     * @type {string}
     * @memberof UniverseDescription
     */
    'title'?: string;
    /**
     * Entity description
     * @type {string}
     * @memberof UniverseDescription
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface UserAttributes
 */
export interface UserAttributes {
    /**
     * 
     * @type {string}
     * @memberof UserAttributes
     */
    'id'?: UserAttributesIdEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserAttributes
     */
    'values'?: Array<string>;
}

export const UserAttributesIdEnum = {
    Tenant: 'tenant',
    Country: 'country',
    StoreId: 'storeId'
} as const;

export type UserAttributesIdEnum = typeof UserAttributesIdEnum[keyof typeof UserAttributesIdEnum];

/**
 * 
 * @export
 * @interface ValidateAddressRequest
 */
export interface ValidateAddressRequest {
    /**
     * 
     * @type {Address}
     * @memberof ValidateAddressRequest
     */
    'address'?: Address;
}
/**
 * 
 * @export
 * @interface ValidateAddressResponse
 */
export interface ValidateAddressResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ValidateAddressResponse
     */
    'valid'?: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ValidateAddressResponse
     */
    'error'?: Error;
    /**
     * 
     * @type {Address}
     * @memberof ValidateAddressResponse
     */
    'address'?: Address;
}

/**
 * DonateApi - axios parameter creator
 * @export
 */
export const DonateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a repair from form page
         * @summary update transaction for Donate
         * @param {number} storeId 
         * @param {number} donateId 
         * @param {string} language 
         * @param {DonateOnlinePaymentRequest} [donateOnlinePaymentRequest] repair created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDonateOnlineCreate: async (storeId: number, donateId: number, language: string, donateOnlinePaymentRequest?: DonateOnlinePaymentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('patchDonateOnlineCreate', 'storeId', storeId)
            // verify required parameter 'donateId' is not null or undefined
            assertParamExists('patchDonateOnlineCreate', 'donateId', donateId)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('patchDonateOnlineCreate', 'language', language)
            const localVarPath = `/itxrest/2/resell-integration/donate/store/{storeId}/donate/{donateId}`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)))
                .replace(`{${"donateId"}}`, encodeURIComponent(String(donateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(donateOnlinePaymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a repair from form page
         * @summary Create donate for store
         * @param {number} storeId 
         * @param {string} language 
         * @param {DonateOnlineRequest} [donateOnlineRequest] repair created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDonateOnlineCreate: async (storeId: number, language: string, donateOnlineRequest?: DonateOnlineRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('postDonateOnlineCreate', 'storeId', storeId)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('postDonateOnlineCreate', 'language', language)
            const localVarPath = `/itxrest/2/resell-integration/donate/store/{storeId}`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(donateOnlineRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DonateApi - functional programming interface
 * @export
 */
export const DonateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DonateApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a repair from form page
         * @summary update transaction for Donate
         * @param {number} storeId 
         * @param {number} donateId 
         * @param {string} language 
         * @param {DonateOnlinePaymentRequest} [donateOnlinePaymentRequest] repair created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchDonateOnlineCreate(storeId: number, donateId: number, language: string, donateOnlinePaymentRequest?: DonateOnlinePaymentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DonateOnline>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchDonateOnlineCreate(storeId, donateId, language, donateOnlinePaymentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a repair from form page
         * @summary Create donate for store
         * @param {number} storeId 
         * @param {string} language 
         * @param {DonateOnlineRequest} [donateOnlineRequest] repair created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDonateOnlineCreate(storeId: number, language: string, donateOnlineRequest?: DonateOnlineRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DonateOnline>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDonateOnlineCreate(storeId, language, donateOnlineRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DonateApi - factory interface
 * @export
 */
export const DonateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DonateApiFp(configuration)
    return {
        /**
         * Create a repair from form page
         * @summary update transaction for Donate
         * @param {number} storeId 
         * @param {number} donateId 
         * @param {string} language 
         * @param {DonateOnlinePaymentRequest} [donateOnlinePaymentRequest] repair created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchDonateOnlineCreate(storeId: number, donateId: number, language: string, donateOnlinePaymentRequest?: DonateOnlinePaymentRequest, options?: any): AxiosPromise<DonateOnline> {
            return localVarFp.patchDonateOnlineCreate(storeId, donateId, language, donateOnlinePaymentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a repair from form page
         * @summary Create donate for store
         * @param {number} storeId 
         * @param {string} language 
         * @param {DonateOnlineRequest} [donateOnlineRequest] repair created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDonateOnlineCreate(storeId: number, language: string, donateOnlineRequest?: DonateOnlineRequest, options?: any): AxiosPromise<DonateOnline> {
            return localVarFp.postDonateOnlineCreate(storeId, language, donateOnlineRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DonateApi - interface
 * @export
 * @interface DonateApi
 */
export interface DonateApiInterface {
    /**
     * Create a repair from form page
     * @summary update transaction for Donate
     * @param {number} storeId 
     * @param {number} donateId 
     * @param {string} language 
     * @param {DonateOnlinePaymentRequest} [donateOnlinePaymentRequest] repair created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DonateApiInterface
     */
    patchDonateOnlineCreate(storeId: number, donateId: number, language: string, donateOnlinePaymentRequest?: DonateOnlinePaymentRequest, options?: AxiosRequestConfig): AxiosPromise<DonateOnline>;

    /**
     * Create a repair from form page
     * @summary Create donate for store
     * @param {number} storeId 
     * @param {string} language 
     * @param {DonateOnlineRequest} [donateOnlineRequest] repair created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DonateApiInterface
     */
    postDonateOnlineCreate(storeId: number, language: string, donateOnlineRequest?: DonateOnlineRequest, options?: AxiosRequestConfig): AxiosPromise<DonateOnline>;

}

/**
 * DonateApi - object-oriented interface
 * @export
 * @class DonateApi
 * @extends {BaseAPI}
 */
export class DonateApi extends BaseAPI implements DonateApiInterface {
    /**
     * Create a repair from form page
     * @summary update transaction for Donate
     * @param {number} storeId 
     * @param {number} donateId 
     * @param {string} language 
     * @param {DonateOnlinePaymentRequest} [donateOnlinePaymentRequest] repair created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DonateApi
     */
    public patchDonateOnlineCreate(storeId: number, donateId: number, language: string, donateOnlinePaymentRequest?: DonateOnlinePaymentRequest, options?: AxiosRequestConfig) {
        return DonateApiFp(this.configuration).patchDonateOnlineCreate(storeId, donateId, language, donateOnlinePaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a repair from form page
     * @summary Create donate for store
     * @param {number} storeId 
     * @param {string} language 
     * @param {DonateOnlineRequest} [donateOnlineRequest] repair created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DonateApi
     */
    public postDonateOnlineCreate(storeId: number, language: string, donateOnlineRequest?: DonateOnlineRequest, options?: AxiosRequestConfig) {
        return DonateApiFp(this.configuration).postDonateOnlineCreate(storeId, language, donateOnlineRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * GridFilterAPIApi - axios parameter creator
 * @export
 */
export const GridFilterAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * allows updating a specific filter
         * @summary Request to edit a grid filter
         * @param {string} gridFilterId The grid filter identifier
         * @param {number} storeId ID of the store this query is directed to
         * @param {Gridfilter} gridfilter services object
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editGridFilter: async (gridFilterId: string, storeId: number, gridfilter: Gridfilter, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridFilterId' is not null or undefined
            assertParamExists('editGridFilter', 'gridFilterId', gridFilterId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('editGridFilter', 'storeId', storeId)
            // verify required parameter 'gridfilter' is not null or undefined
            assertParamExists('editGridFilter', 'gridfilter', gridfilter)
            const localVarPath = `/resell-admin/v3/gridfilter/{gridFilterId}`
                .replace(`{${"gridFilterId"}}`, encodeURIComponent(String(gridFilterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gridfilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * allows updating a specific filter
         * @summary Request to update a search Filter
         * @param {string} gridFilterId The grid filter identifier
         * @param {string} gridId The grid identifier
         * @param {number} storeId ID of the store this query is directed to
         * @param {Gridfilters} gridfilters services object
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCriteriaGrid: async (gridFilterId: string, gridId: string, storeId: number, gridfilters: Gridfilters, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridFilterId' is not null or undefined
            assertParamExists('updateCriteriaGrid', 'gridFilterId', gridFilterId)
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('updateCriteriaGrid', 'gridId', gridId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('updateCriteriaGrid', 'storeId', storeId)
            // verify required parameter 'gridfilters' is not null or undefined
            assertParamExists('updateCriteriaGrid', 'gridfilters', gridfilters)
            const localVarPath = `/resell-admin/v3/grid/{gridId}/gridfilters/{gridFilterId}`
                .replace(`{${"gridFilterId"}}`, encodeURIComponent(String(gridFilterId)))
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(gridfilters, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GridFilterAPIApi - functional programming interface
 * @export
 */
export const GridFilterAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GridFilterAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * allows updating a specific filter
         * @summary Request to edit a grid filter
         * @param {string} gridFilterId The grid filter identifier
         * @param {number} storeId ID of the store this query is directed to
         * @param {Gridfilter} gridfilter services object
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editGridFilter(gridFilterId: string, storeId: number, gridfilter: Gridfilter, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editGridFilter(gridFilterId, storeId, gridfilter, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * allows updating a specific filter
         * @summary Request to update a search Filter
         * @param {string} gridFilterId The grid filter identifier
         * @param {string} gridId The grid identifier
         * @param {number} storeId ID of the store this query is directed to
         * @param {Gridfilters} gridfilters services object
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCriteriaGrid(gridFilterId: string, gridId: string, storeId: number, gridfilters: Gridfilters, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCriteriaGrid(gridFilterId, gridId, storeId, gridfilters, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GridFilterAPIApi - factory interface
 * @export
 */
export const GridFilterAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GridFilterAPIApiFp(configuration)
    return {
        /**
         * allows updating a specific filter
         * @summary Request to edit a grid filter
         * @param {string} gridFilterId The grid filter identifier
         * @param {number} storeId ID of the store this query is directed to
         * @param {Gridfilter} gridfilter services object
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editGridFilter(gridFilterId: string, storeId: number, gridfilter: Gridfilter, lang?: string, options?: any): AxiosPromise<void> {
            return localVarFp.editGridFilter(gridFilterId, storeId, gridfilter, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * allows updating a specific filter
         * @summary Request to update a search Filter
         * @param {string} gridFilterId The grid filter identifier
         * @param {string} gridId The grid identifier
         * @param {number} storeId ID of the store this query is directed to
         * @param {Gridfilters} gridfilters services object
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCriteriaGrid(gridFilterId: string, gridId: string, storeId: number, gridfilters: Gridfilters, lang?: string, options?: any): AxiosPromise<void> {
            return localVarFp.updateCriteriaGrid(gridFilterId, gridId, storeId, gridfilters, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GridFilterAPIApi - interface
 * @export
 * @interface GridFilterAPIApi
 */
export interface GridFilterAPIApiInterface {
    /**
     * allows updating a specific filter
     * @summary Request to edit a grid filter
     * @param {string} gridFilterId The grid filter identifier
     * @param {number} storeId ID of the store this query is directed to
     * @param {Gridfilter} gridfilter services object
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridFilterAPIApiInterface
     */
    editGridFilter(gridFilterId: string, storeId: number, gridfilter: Gridfilter, lang?: string, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * allows updating a specific filter
     * @summary Request to update a search Filter
     * @param {string} gridFilterId The grid filter identifier
     * @param {string} gridId The grid identifier
     * @param {number} storeId ID of the store this query is directed to
     * @param {Gridfilters} gridfilters services object
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridFilterAPIApiInterface
     */
    updateCriteriaGrid(gridFilterId: string, gridId: string, storeId: number, gridfilters: Gridfilters, lang?: string, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * GridFilterAPIApi - object-oriented interface
 * @export
 * @class GridFilterAPIApi
 * @extends {BaseAPI}
 */
export class GridFilterAPIApi extends BaseAPI implements GridFilterAPIApiInterface {
    /**
     * allows updating a specific filter
     * @summary Request to edit a grid filter
     * @param {string} gridFilterId The grid filter identifier
     * @param {number} storeId ID of the store this query is directed to
     * @param {Gridfilter} gridfilter services object
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridFilterAPIApi
     */
    public editGridFilter(gridFilterId: string, storeId: number, gridfilter: Gridfilter, lang?: string, options?: AxiosRequestConfig) {
        return GridFilterAPIApiFp(this.configuration).editGridFilter(gridFilterId, storeId, gridfilter, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * allows updating a specific filter
     * @summary Request to update a search Filter
     * @param {string} gridFilterId The grid filter identifier
     * @param {string} gridId The grid identifier
     * @param {number} storeId ID of the store this query is directed to
     * @param {Gridfilters} gridfilters services object
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GridFilterAPIApi
     */
    public updateCriteriaGrid(gridFilterId: string, gridId: string, storeId: number, gridfilters: Gridfilters, lang?: string, options?: AxiosRequestConfig) {
        return GridFilterAPIApiFp(this.configuration).updateCriteriaGrid(gridFilterId, gridId, storeId, gridfilters, lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * IaHybridSearchApi - axios parameter creator
 * @export
 */
export const IaHybridSearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * get ia hydrid search results from given data
         * @summary get ia hydrid search results from given data
         * @param {number} storeId ID of the store this query is directed to
         * @param {File} uploadedImage 
         * @param {number} k 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postIaHybridSearch: async (storeId: number, uploadedImage: File, k: number, lang?: string, page?: number, size?: number, sort?: Array<string>, year?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('postIaHybridSearch', 'storeId', storeId)
            // verify required parameter 'uploadedImage' is not null or undefined
            assertParamExists('postIaHybridSearch', 'uploadedImage', uploadedImage)
            // verify required parameter 'k' is not null or undefined
            assertParamExists('postIaHybridSearch', 'k', k)
            const localVarPath = `/itxrest/1/resell-integration/ia/hybrid/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


            if (uploadedImage !== undefined) { 
                localVarFormParams.append('uploadedImage', uploadedImage as any);
            }
    
            if (k !== undefined) { 
                localVarFormParams.append('k', k as any);
            }
    
            if (year !== undefined) { 
                localVarFormParams.append('year', year as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IaHybridSearchApi - functional programming interface
 * @export
 */
export const IaHybridSearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IaHybridSearchApiAxiosParamCreator(configuration)
    return {
        /**
         * get ia hydrid search results from given data
         * @summary get ia hydrid search results from given data
         * @param {number} storeId ID of the store this query is directed to
         * @param {File} uploadedImage 
         * @param {number} k 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postIaHybridSearch(storeId: number, uploadedImage: File, k: number, lang?: string, page?: number, size?: number, sort?: Array<string>, year?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HybridSearchResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postIaHybridSearch(storeId, uploadedImage, k, lang, page, size, sort, year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IaHybridSearchApi - factory interface
 * @export
 */
export const IaHybridSearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IaHybridSearchApiFp(configuration)
    return {
        /**
         * get ia hydrid search results from given data
         * @summary get ia hydrid search results from given data
         * @param {number} storeId ID of the store this query is directed to
         * @param {File} uploadedImage 
         * @param {number} k 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postIaHybridSearch(storeId: number, uploadedImage: File, k: number, lang?: string, page?: number, size?: number, sort?: Array<string>, year?: number, options?: any): AxiosPromise<HybridSearchResponse> {
            return localVarFp.postIaHybridSearch(storeId, uploadedImage, k, lang, page, size, sort, year, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IaHybridSearchApi - interface
 * @export
 * @interface IaHybridSearchApi
 */
export interface IaHybridSearchApiInterface {
    /**
     * get ia hydrid search results from given data
     * @summary get ia hydrid search results from given data
     * @param {number} storeId ID of the store this query is directed to
     * @param {File} uploadedImage 
     * @param {number} k 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [year] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaHybridSearchApiInterface
     */
    postIaHybridSearch(storeId: number, uploadedImage: File, k: number, lang?: string, page?: number, size?: number, sort?: Array<string>, year?: number, options?: AxiosRequestConfig): AxiosPromise<HybridSearchResponse>;

}

/**
 * IaHybridSearchApi - object-oriented interface
 * @export
 * @class IaHybridSearchApi
 * @extends {BaseAPI}
 */
export class IaHybridSearchApi extends BaseAPI implements IaHybridSearchApiInterface {
    /**
     * get ia hydrid search results from given data
     * @summary get ia hydrid search results from given data
     * @param {number} storeId ID of the store this query is directed to
     * @param {File} uploadedImage 
     * @param {number} k 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {number} [year] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaHybridSearchApi
     */
    public postIaHybridSearch(storeId: number, uploadedImage: File, k: number, lang?: string, page?: number, size?: number, sort?: Array<string>, year?: number, options?: AxiosRequestConfig) {
        return IaHybridSearchApiFp(this.configuration).postIaHybridSearch(storeId, uploadedImage, k, lang, page, size, sort, year, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * IaModerationApi - axios parameter creator
 * @export
 */
export const IaModerationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * delete moderation ia flow with the given configuration
         * @summary delete moderation ia flow with the given configuration
         * @param {string} flowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIaModerationFlow: async (flowId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowId' is not null or undefined
            assertParamExists('deleteIaModerationFlow', 'flowId', flowId)
            const localVarPath = `/itxrest/1/resell-integration/ia/moderation/flow/{flowId}`
                .replace(`{${"flowId"}}`, encodeURIComponent(String(flowId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get moderation ia flow with the given configuration
         * @summary get moderation ia flow with the given configuration
         * @param {string} flowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIaModerationFlow: async (flowId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowId' is not null or undefined
            assertParamExists('getIaModerationFlow', 'flowId', flowId)
            const localVarPath = `/itxrest/1/resell-integration/ia/moderation/flow/{flowId}`
                .replace(`{${"flowId"}}`, encodeURIComponent(String(flowId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get all moderation ia flows
         * @summary get all moderation ia flows
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIaModerationFlows: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/itxrest/1/resell-integration/ia/moderation/flow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get IA Moderation results
         * @summary Get IA moderation results
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIaModerationResults: async (storeId: number, productId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getIaModerationResults', 'storeId', storeId)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('getIaModerationResults', 'productId', productId)
            const localVarPath = `/itxrest/1/resell-integration/ia/moderation/results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (productId !== undefined) {
                localVarQueryParameter['productId'] = productId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * create moderation ia flow with the given configuration
         * @summary create moderation ia flow with the given configuration
         * @param {ModerationFlowRequest} [moderationFlowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postIaModerationFlow: async (moderationFlowRequest?: ModerationFlowRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/itxrest/1/resell-integration/ia/moderation/flow`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moderationFlowRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add new reject reasons mapping enum mecresprad and enum shopizer
         * @param {RejectReasonRequest} [rejectReasonRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRejectReasons: async (rejectReasonRequest?: RejectReasonRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/itxrest/1/resell-integration/reject-reasons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rejectReasonRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update moderation ia flow with the given configuration
         * @summary update moderation ia flow with the given configuration
         * @param {string} flowId 
         * @param {ModerationFlowRequest} [moderationFlowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putIaModerationFlow: async (flowId: string, moderationFlowRequest?: ModerationFlowRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowId' is not null or undefined
            assertParamExists('putIaModerationFlow', 'flowId', flowId)
            const localVarPath = `/itxrest/1/resell-integration/ia/moderation/flow/{flowId}`
                .replace(`{${"flowId"}}`, encodeURIComponent(String(flowId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moderationFlowRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * activate moderation ia flow with the given configuration
         * @summary activate moderation ia flow with the given configuration
         * @param {string} flowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putIaModerationFlowDefault: async (flowId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'flowId' is not null or undefined
            assertParamExists('putIaModerationFlowDefault', 'flowId', flowId)
            const localVarPath = `/itxrest/1/resell-integration/ia/moderation/flow/{flowId}/default`
                .replace(`{${"flowId"}}`, encodeURIComponent(String(flowId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IaModerationApi - functional programming interface
 * @export
 */
export const IaModerationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IaModerationApiAxiosParamCreator(configuration)
    return {
        /**
         * delete moderation ia flow with the given configuration
         * @summary delete moderation ia flow with the given configuration
         * @param {string} flowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteIaModerationFlow(flowId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteIaModerationFlow(flowId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get moderation ia flow with the given configuration
         * @summary get moderation ia flow with the given configuration
         * @param {string} flowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIaModerationFlow(flowId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModerationFlowResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIaModerationFlow(flowId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get all moderation ia flows
         * @summary get all moderation ia flows
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIaModerationFlows(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ModerationFlowResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIaModerationFlows(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get IA Moderation results
         * @summary Get IA moderation results
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIaModerationResults(storeId: number, productId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IAModerationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIaModerationResults(storeId, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * create moderation ia flow with the given configuration
         * @summary create moderation ia flow with the given configuration
         * @param {ModerationFlowRequest} [moderationFlowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postIaModerationFlow(moderationFlowRequest?: ModerationFlowRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModerationFlowResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postIaModerationFlow(moderationFlowRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add new reject reasons mapping enum mecresprad and enum shopizer
         * @param {RejectReasonRequest} [rejectReasonRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postRejectReasons(rejectReasonRequest?: RejectReasonRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postRejectReasons(rejectReasonRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update moderation ia flow with the given configuration
         * @summary update moderation ia flow with the given configuration
         * @param {string} flowId 
         * @param {ModerationFlowRequest} [moderationFlowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putIaModerationFlow(flowId: string, moderationFlowRequest?: ModerationFlowRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModerationFlowResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putIaModerationFlow(flowId, moderationFlowRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * activate moderation ia flow with the given configuration
         * @summary activate moderation ia flow with the given configuration
         * @param {string} flowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putIaModerationFlowDefault(flowId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModerationFlowResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putIaModerationFlowDefault(flowId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IaModerationApi - factory interface
 * @export
 */
export const IaModerationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IaModerationApiFp(configuration)
    return {
        /**
         * delete moderation ia flow with the given configuration
         * @summary delete moderation ia flow with the given configuration
         * @param {string} flowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteIaModerationFlow(flowId: string, options?: any): AxiosPromise<OperationResult> {
            return localVarFp.deleteIaModerationFlow(flowId, options).then((request) => request(axios, basePath));
        },
        /**
         * get moderation ia flow with the given configuration
         * @summary get moderation ia flow with the given configuration
         * @param {string} flowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIaModerationFlow(flowId: string, options?: any): AxiosPromise<ModerationFlowResponse> {
            return localVarFp.getIaModerationFlow(flowId, options).then((request) => request(axios, basePath));
        },
        /**
         * get all moderation ia flows
         * @summary get all moderation ia flows
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIaModerationFlows(options?: any): AxiosPromise<Array<ModerationFlowResponse>> {
            return localVarFp.getIaModerationFlows(options).then((request) => request(axios, basePath));
        },
        /**
         * Get IA Moderation results
         * @summary Get IA moderation results
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIaModerationResults(storeId: number, productId: number, options?: any): AxiosPromise<IAModerationResponse> {
            return localVarFp.getIaModerationResults(storeId, productId, options).then((request) => request(axios, basePath));
        },
        /**
         * create moderation ia flow with the given configuration
         * @summary create moderation ia flow with the given configuration
         * @param {ModerationFlowRequest} [moderationFlowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postIaModerationFlow(moderationFlowRequest?: ModerationFlowRequest, options?: any): AxiosPromise<ModerationFlowResponse> {
            return localVarFp.postIaModerationFlow(moderationFlowRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add new reject reasons mapping enum mecresprad and enum shopizer
         * @param {RejectReasonRequest} [rejectReasonRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRejectReasons(rejectReasonRequest?: RejectReasonRequest, options?: any): AxiosPromise<void> {
            return localVarFp.postRejectReasons(rejectReasonRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * update moderation ia flow with the given configuration
         * @summary update moderation ia flow with the given configuration
         * @param {string} flowId 
         * @param {ModerationFlowRequest} [moderationFlowRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putIaModerationFlow(flowId: string, moderationFlowRequest?: ModerationFlowRequest, options?: any): AxiosPromise<ModerationFlowResponse> {
            return localVarFp.putIaModerationFlow(flowId, moderationFlowRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * activate moderation ia flow with the given configuration
         * @summary activate moderation ia flow with the given configuration
         * @param {string} flowId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putIaModerationFlowDefault(flowId: string, options?: any): AxiosPromise<ModerationFlowResponse> {
            return localVarFp.putIaModerationFlowDefault(flowId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IaModerationApi - interface
 * @export
 * @interface IaModerationApi
 */
export interface IaModerationApiInterface {
    /**
     * delete moderation ia flow with the given configuration
     * @summary delete moderation ia flow with the given configuration
     * @param {string} flowId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaModerationApiInterface
     */
    deleteIaModerationFlow(flowId: string, options?: AxiosRequestConfig): AxiosPromise<OperationResult>;

    /**
     * get moderation ia flow with the given configuration
     * @summary get moderation ia flow with the given configuration
     * @param {string} flowId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaModerationApiInterface
     */
    getIaModerationFlow(flowId: string, options?: AxiosRequestConfig): AxiosPromise<ModerationFlowResponse>;

    /**
     * get all moderation ia flows
     * @summary get all moderation ia flows
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaModerationApiInterface
     */
    getIaModerationFlows(options?: AxiosRequestConfig): AxiosPromise<Array<ModerationFlowResponse>>;

    /**
     * Get IA Moderation results
     * @summary Get IA moderation results
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaModerationApiInterface
     */
    getIaModerationResults(storeId: number, productId: number, options?: AxiosRequestConfig): AxiosPromise<IAModerationResponse>;

    /**
     * create moderation ia flow with the given configuration
     * @summary create moderation ia flow with the given configuration
     * @param {ModerationFlowRequest} [moderationFlowRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaModerationApiInterface
     */
    postIaModerationFlow(moderationFlowRequest?: ModerationFlowRequest, options?: AxiosRequestConfig): AxiosPromise<ModerationFlowResponse>;

    /**
     * 
     * @summary Add new reject reasons mapping enum mecresprad and enum shopizer
     * @param {RejectReasonRequest} [rejectReasonRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaModerationApiInterface
     */
    postRejectReasons(rejectReasonRequest?: RejectReasonRequest, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * update moderation ia flow with the given configuration
     * @summary update moderation ia flow with the given configuration
     * @param {string} flowId 
     * @param {ModerationFlowRequest} [moderationFlowRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaModerationApiInterface
     */
    putIaModerationFlow(flowId: string, moderationFlowRequest?: ModerationFlowRequest, options?: AxiosRequestConfig): AxiosPromise<ModerationFlowResponse>;

    /**
     * activate moderation ia flow with the given configuration
     * @summary activate moderation ia flow with the given configuration
     * @param {string} flowId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaModerationApiInterface
     */
    putIaModerationFlowDefault(flowId: string, options?: AxiosRequestConfig): AxiosPromise<ModerationFlowResponse>;

}

/**
 * IaModerationApi - object-oriented interface
 * @export
 * @class IaModerationApi
 * @extends {BaseAPI}
 */
export class IaModerationApi extends BaseAPI implements IaModerationApiInterface {
    /**
     * delete moderation ia flow with the given configuration
     * @summary delete moderation ia flow with the given configuration
     * @param {string} flowId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaModerationApi
     */
    public deleteIaModerationFlow(flowId: string, options?: AxiosRequestConfig) {
        return IaModerationApiFp(this.configuration).deleteIaModerationFlow(flowId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get moderation ia flow with the given configuration
     * @summary get moderation ia flow with the given configuration
     * @param {string} flowId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaModerationApi
     */
    public getIaModerationFlow(flowId: string, options?: AxiosRequestConfig) {
        return IaModerationApiFp(this.configuration).getIaModerationFlow(flowId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get all moderation ia flows
     * @summary get all moderation ia flows
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaModerationApi
     */
    public getIaModerationFlows(options?: AxiosRequestConfig) {
        return IaModerationApiFp(this.configuration).getIaModerationFlows(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get IA Moderation results
     * @summary Get IA moderation results
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaModerationApi
     */
    public getIaModerationResults(storeId: number, productId: number, options?: AxiosRequestConfig) {
        return IaModerationApiFp(this.configuration).getIaModerationResults(storeId, productId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * create moderation ia flow with the given configuration
     * @summary create moderation ia flow with the given configuration
     * @param {ModerationFlowRequest} [moderationFlowRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaModerationApi
     */
    public postIaModerationFlow(moderationFlowRequest?: ModerationFlowRequest, options?: AxiosRequestConfig) {
        return IaModerationApiFp(this.configuration).postIaModerationFlow(moderationFlowRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add new reject reasons mapping enum mecresprad and enum shopizer
     * @param {RejectReasonRequest} [rejectReasonRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaModerationApi
     */
    public postRejectReasons(rejectReasonRequest?: RejectReasonRequest, options?: AxiosRequestConfig) {
        return IaModerationApiFp(this.configuration).postRejectReasons(rejectReasonRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update moderation ia flow with the given configuration
     * @summary update moderation ia flow with the given configuration
     * @param {string} flowId 
     * @param {ModerationFlowRequest} [moderationFlowRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaModerationApi
     */
    public putIaModerationFlow(flowId: string, moderationFlowRequest?: ModerationFlowRequest, options?: AxiosRequestConfig) {
        return IaModerationApiFp(this.configuration).putIaModerationFlow(flowId, moderationFlowRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * activate moderation ia flow with the given configuration
     * @summary activate moderation ia flow with the given configuration
     * @param {string} flowId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IaModerationApi
     */
    public putIaModerationFlowDefault(flowId: string, options?: AxiosRequestConfig) {
        return IaModerationApiFp(this.configuration).putIaModerationFlowDefault(flowId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ImageServiceApi - axios parameter creator
 * @export
 */
export const ImageServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Login for AI image service
         * @summary Login for AI image service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageServiceLogin: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/itxrest/1/resell-integration/azure/image-service-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImageServiceApi - functional programming interface
 * @export
 */
export const ImageServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImageServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * Login for AI image service
         * @summary Login for AI image service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImageServiceLogin(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImageServiceOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImageServiceLogin(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ImageServiceApi - factory interface
 * @export
 */
export const ImageServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImageServiceApiFp(configuration)
    return {
        /**
         * Login for AI image service
         * @summary Login for AI image service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageServiceLogin(options?: any): AxiosPromise<ImageServiceOutput> {
            return localVarFp.getImageServiceLogin(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ImageServiceApi - interface
 * @export
 * @interface ImageServiceApi
 */
export interface ImageServiceApiInterface {
    /**
     * Login for AI image service
     * @summary Login for AI image service
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImageServiceApiInterface
     */
    getImageServiceLogin(options?: AxiosRequestConfig): AxiosPromise<ImageServiceOutput>;

}

/**
 * ImageServiceApi - object-oriented interface
 * @export
 * @class ImageServiceApi
 * @extends {BaseAPI}
 */
export class ImageServiceApi extends BaseAPI implements ImageServiceApiInterface {
    /**
     * Login for AI image service
     * @summary Login for AI image service
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImageServiceApi
     */
    public getImageServiceLogin(options?: AxiosRequestConfig) {
        return ImageServiceApiFp(this.configuration).getImageServiceLogin(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * IntegrationAuthApi - axios parameter creator
 * @export
 */
export const IntegrationAuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get current user info with roles and attibrutes, encrypted by secret key for the user who made the call
         * @summary Get current user info with roles and attibrutes, encrypted by secret key for the user who made the call
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthToken: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/resell-integration/auth/tokenWithRoles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get data from decrypted token
         * @summary Get data from decrypted token
         * @param {DecryptTokenRequest} [decryptTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDecryptToken: async (decryptTokenRequest?: DecryptTokenRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/resell-integration/auth/decryptToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(decryptTokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntegrationAuthApi - functional programming interface
 * @export
 */
export const IntegrationAuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IntegrationAuthApiAxiosParamCreator(configuration)
    return {
        /**
         * Get current user info with roles and attibrutes, encrypted by secret key for the user who made the call
         * @summary Get current user info with roles and attibrutes, encrypted by secret key for the user who made the call
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthToken(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthToken(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get data from decrypted token
         * @summary Get data from decrypted token
         * @param {DecryptTokenRequest} [decryptTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDecryptToken(decryptTokenRequest?: DecryptTokenRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResellBackofficeUser>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDecryptToken(decryptTokenRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IntegrationAuthApi - factory interface
 * @export
 */
export const IntegrationAuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IntegrationAuthApiFp(configuration)
    return {
        /**
         * Get current user info with roles and attibrutes, encrypted by secret key for the user who made the call
         * @summary Get current user info with roles and attibrutes, encrypted by secret key for the user who made the call
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthToken(options?: any): AxiosPromise<AuthTokenResponse> {
            return localVarFp.getAuthToken(options).then((request) => request(axios, basePath));
        },
        /**
         * Get data from decrypted token
         * @summary Get data from decrypted token
         * @param {DecryptTokenRequest} [decryptTokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDecryptToken(decryptTokenRequest?: DecryptTokenRequest, options?: any): AxiosPromise<ResellBackofficeUser> {
            return localVarFp.postDecryptToken(decryptTokenRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IntegrationAuthApi - interface
 * @export
 * @interface IntegrationAuthApi
 */
export interface IntegrationAuthApiInterface {
    /**
     * Get current user info with roles and attibrutes, encrypted by secret key for the user who made the call
     * @summary Get current user info with roles and attibrutes, encrypted by secret key for the user who made the call
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationAuthApiInterface
     */
    getAuthToken(options?: AxiosRequestConfig): AxiosPromise<AuthTokenResponse>;

    /**
     * Get data from decrypted token
     * @summary Get data from decrypted token
     * @param {DecryptTokenRequest} [decryptTokenRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationAuthApiInterface
     */
    postDecryptToken(decryptTokenRequest?: DecryptTokenRequest, options?: AxiosRequestConfig): AxiosPromise<ResellBackofficeUser>;

}

/**
 * IntegrationAuthApi - object-oriented interface
 * @export
 * @class IntegrationAuthApi
 * @extends {BaseAPI}
 */
export class IntegrationAuthApi extends BaseAPI implements IntegrationAuthApiInterface {
    /**
     * Get current user info with roles and attibrutes, encrypted by secret key for the user who made the call
     * @summary Get current user info with roles and attibrutes, encrypted by secret key for the user who made the call
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationAuthApi
     */
    public getAuthToken(options?: AxiosRequestConfig) {
        return IntegrationAuthApiFp(this.configuration).getAuthToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get data from decrypted token
     * @summary Get data from decrypted token
     * @param {DecryptTokenRequest} [decryptTokenRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationAuthApi
     */
    public postDecryptToken(decryptTokenRequest?: DecryptTokenRequest, options?: AxiosRequestConfig) {
        return IntegrationAuthApiFp(this.configuration).postDecryptToken(decryptTokenRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * IntegrationL10nBlackListApi - axios parameter creator
 * @export
 */
export const IntegrationL10nBlackListApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List of tokens to add
         * @summary Adds tokens to a blacklist. Tokens already present are ignored.
         * @param {string} blacklistId Blacklist ID
         * @param {Array<Token>} [token] Single text check parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResellIntegrationL10nBlacklistAddTokens: async (blacklistId: string, token?: Array<Token>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blacklistId' is not null or undefined
            assertParamExists('postResellIntegrationL10nBlacklistAddTokens', 'blacklistId', blacklistId)
            const localVarPath = `/resell-integration/l10n/blacklist/{blacklistId}/tokens`
                .replace(`{${"blacklistId"}}`, encodeURIComponent(String(blacklistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(token, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new blacklist with the specified parameters.
         * @summary Create a new blacklist
         * @param {BlacklistCreationParams} blacklistCreationParams Blacklist paramaters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResellIntegrationL10nBlacklistCreate: async (blacklistCreationParams: BlacklistCreationParams, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'blacklistCreationParams' is not null or undefined
            assertParamExists('postResellIntegrationL10nBlacklistCreate', 'blacklistCreationParams', blacklistCreationParams)
            const localVarPath = `/resell-integration/l10n/blacklists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(blacklistCreationParams, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves existing blacklists
         * @summary Retrieve blacklists
         * @param {number} [offset] Number of items to skip.
         * @param {number} [limit] Number of items in each page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResellIntegrationL10nBlacklistList: async (offset?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/resell-integration/l10n/blacklists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  description: Performs a blacklist check on the provided text, for all specified blacklists.         Additionally, if a storeId was specified and an external blacklist provider is configured for the store, text will also be sent for analysis.         Returns *true* if any blacklist match or analysis issue was found.
         * @summary 
         * @param {CheckingSingleText} [checkingSingleText] Single text check parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResellIntegrationL10nBlacklistTextsSingleCheck: async (checkingSingleText?: CheckingSingleText, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/resell-integration/l10n/blacklist/texts/single-check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(checkingSingleText, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntegrationL10nBlackListApi - functional programming interface
 * @export
 */
export const IntegrationL10nBlackListApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IntegrationL10nBlackListApiAxiosParamCreator(configuration)
    return {
        /**
         * List of tokens to add
         * @summary Adds tokens to a blacklist. Tokens already present are ignored.
         * @param {string} blacklistId Blacklist ID
         * @param {Array<Token>} [token] Single text check parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postResellIntegrationL10nBlacklistAddTokens(blacklistId: string, token?: Array<Token>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OperationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postResellIntegrationL10nBlacklistAddTokens(blacklistId, token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a new blacklist with the specified parameters.
         * @summary Create a new blacklist
         * @param {BlacklistCreationParams} blacklistCreationParams Blacklist paramaters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postResellIntegrationL10nBlacklistCreate(blacklistCreationParams: BlacklistCreationParams, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Blacklist>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postResellIntegrationL10nBlacklistCreate(blacklistCreationParams, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retrieves existing blacklists
         * @summary Retrieve blacklists
         * @param {number} [offset] Number of items to skip.
         * @param {number} [limit] Number of items in each page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postResellIntegrationL10nBlacklistList(offset?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageOfBlacklist>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postResellIntegrationL10nBlacklistList(offset, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         *  description: Performs a blacklist check on the provided text, for all specified blacklists.         Additionally, if a storeId was specified and an external blacklist provider is configured for the store, text will also be sent for analysis.         Returns *true* if any blacklist match or analysis issue was found.
         * @summary 
         * @param {CheckingSingleText} [checkingSingleText] Single text check parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postResellIntegrationL10nBlacklistTextsSingleCheck(checkingSingleText?: CheckingSingleText, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckingResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postResellIntegrationL10nBlacklistTextsSingleCheck(checkingSingleText, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IntegrationL10nBlackListApi - factory interface
 * @export
 */
export const IntegrationL10nBlackListApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IntegrationL10nBlackListApiFp(configuration)
    return {
        /**
         * List of tokens to add
         * @summary Adds tokens to a blacklist. Tokens already present are ignored.
         * @param {string} blacklistId Blacklist ID
         * @param {Array<Token>} [token] Single text check parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResellIntegrationL10nBlacklistAddTokens(blacklistId: string, token?: Array<Token>, options?: any): AxiosPromise<OperationResult> {
            return localVarFp.postResellIntegrationL10nBlacklistAddTokens(blacklistId, token, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new blacklist with the specified parameters.
         * @summary Create a new blacklist
         * @param {BlacklistCreationParams} blacklistCreationParams Blacklist paramaters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResellIntegrationL10nBlacklistCreate(blacklistCreationParams: BlacklistCreationParams, options?: any): AxiosPromise<Blacklist> {
            return localVarFp.postResellIntegrationL10nBlacklistCreate(blacklistCreationParams, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves existing blacklists
         * @summary Retrieve blacklists
         * @param {number} [offset] Number of items to skip.
         * @param {number} [limit] Number of items in each page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResellIntegrationL10nBlacklistList(offset?: number, limit?: number, options?: any): AxiosPromise<PageOfBlacklist> {
            return localVarFp.postResellIntegrationL10nBlacklistList(offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         *  description: Performs a blacklist check on the provided text, for all specified blacklists.         Additionally, if a storeId was specified and an external blacklist provider is configured for the store, text will also be sent for analysis.         Returns *true* if any blacklist match or analysis issue was found.
         * @summary 
         * @param {CheckingSingleText} [checkingSingleText] Single text check parameters
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResellIntegrationL10nBlacklistTextsSingleCheck(checkingSingleText?: CheckingSingleText, options?: any): AxiosPromise<CheckingResult> {
            return localVarFp.postResellIntegrationL10nBlacklistTextsSingleCheck(checkingSingleText, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IntegrationL10nBlackListApi - interface
 * @export
 * @interface IntegrationL10nBlackListApi
 */
export interface IntegrationL10nBlackListApiInterface {
    /**
     * List of tokens to add
     * @summary Adds tokens to a blacklist. Tokens already present are ignored.
     * @param {string} blacklistId Blacklist ID
     * @param {Array<Token>} [token] Single text check parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationL10nBlackListApiInterface
     */
    postResellIntegrationL10nBlacklistAddTokens(blacklistId: string, token?: Array<Token>, options?: AxiosRequestConfig): AxiosPromise<OperationResult>;

    /**
     * Creates a new blacklist with the specified parameters.
     * @summary Create a new blacklist
     * @param {BlacklistCreationParams} blacklistCreationParams Blacklist paramaters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationL10nBlackListApiInterface
     */
    postResellIntegrationL10nBlacklistCreate(blacklistCreationParams: BlacklistCreationParams, options?: AxiosRequestConfig): AxiosPromise<Blacklist>;

    /**
     * Retrieves existing blacklists
     * @summary Retrieve blacklists
     * @param {number} [offset] Number of items to skip.
     * @param {number} [limit] Number of items in each page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationL10nBlackListApiInterface
     */
    postResellIntegrationL10nBlacklistList(offset?: number, limit?: number, options?: AxiosRequestConfig): AxiosPromise<PageOfBlacklist>;

    /**
     *  description: Performs a blacklist check on the provided text, for all specified blacklists.         Additionally, if a storeId was specified and an external blacklist provider is configured for the store, text will also be sent for analysis.         Returns *true* if any blacklist match or analysis issue was found.
     * @summary 
     * @param {CheckingSingleText} [checkingSingleText] Single text check parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationL10nBlackListApiInterface
     */
    postResellIntegrationL10nBlacklistTextsSingleCheck(checkingSingleText?: CheckingSingleText, options?: AxiosRequestConfig): AxiosPromise<CheckingResult>;

}

/**
 * IntegrationL10nBlackListApi - object-oriented interface
 * @export
 * @class IntegrationL10nBlackListApi
 * @extends {BaseAPI}
 */
export class IntegrationL10nBlackListApi extends BaseAPI implements IntegrationL10nBlackListApiInterface {
    /**
     * List of tokens to add
     * @summary Adds tokens to a blacklist. Tokens already present are ignored.
     * @param {string} blacklistId Blacklist ID
     * @param {Array<Token>} [token] Single text check parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationL10nBlackListApi
     */
    public postResellIntegrationL10nBlacklistAddTokens(blacklistId: string, token?: Array<Token>, options?: AxiosRequestConfig) {
        return IntegrationL10nBlackListApiFp(this.configuration).postResellIntegrationL10nBlacklistAddTokens(blacklistId, token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new blacklist with the specified parameters.
     * @summary Create a new blacklist
     * @param {BlacklistCreationParams} blacklistCreationParams Blacklist paramaters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationL10nBlackListApi
     */
    public postResellIntegrationL10nBlacklistCreate(blacklistCreationParams: BlacklistCreationParams, options?: AxiosRequestConfig) {
        return IntegrationL10nBlackListApiFp(this.configuration).postResellIntegrationL10nBlacklistCreate(blacklistCreationParams, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves existing blacklists
     * @summary Retrieve blacklists
     * @param {number} [offset] Number of items to skip.
     * @param {number} [limit] Number of items in each page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationL10nBlackListApi
     */
    public postResellIntegrationL10nBlacklistList(offset?: number, limit?: number, options?: AxiosRequestConfig) {
        return IntegrationL10nBlackListApiFp(this.configuration).postResellIntegrationL10nBlacklistList(offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  description: Performs a blacklist check on the provided text, for all specified blacklists.         Additionally, if a storeId was specified and an external blacklist provider is configured for the store, text will also be sent for analysis.         Returns *true* if any blacklist match or analysis issue was found.
     * @summary 
     * @param {CheckingSingleText} [checkingSingleText] Single text check parameters
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationL10nBlackListApi
     */
    public postResellIntegrationL10nBlacklistTextsSingleCheck(checkingSingleText?: CheckingSingleText, options?: AxiosRequestConfig) {
        return IntegrationL10nBlackListApiFp(this.configuration).postResellIntegrationL10nBlacklistTextsSingleCheck(checkingSingleText, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * IntegrationL10nLionatApi - axios parameter creator
 * @export
 */
export const IntegrationL10nLionatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Automatic text translation service
         * @summary Automatic text translation service
         * @param {TranslateInput} [translateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTranslatePrivate: async (translateInput?: TranslateInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/1/resell-integration/l10n/lionat/text/translate-private`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(translateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Automatic text translation service
         * @summary Automatic text translation service
         * @param {number} productId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {TranslateInputPublic} [translateInputPublic] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTranslatePublic: async (productId: number, storeId: number, lang?: string, translateInputPublic?: TranslateInputPublic, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('postTranslatePublic', 'productId', productId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('postTranslatePublic', 'storeId', storeId)
            const localVarPath = `/itxrest/1/resell-integration/l10n/lionat/text/translate-public/{productId}`
                .replace(`{${"productId"}}`, encodeURIComponent(String(productId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(translateInputPublic, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IntegrationL10nLionatApi - functional programming interface
 * @export
 */
export const IntegrationL10nLionatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IntegrationL10nLionatApiAxiosParamCreator(configuration)
    return {
        /**
         * Automatic text translation service
         * @summary Automatic text translation service
         * @param {TranslateInput} [translateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postTranslatePrivate(translateInput?: TranslateInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TranslateOutput>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postTranslatePrivate(translateInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Automatic text translation service
         * @summary Automatic text translation service
         * @param {number} productId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {TranslateInputPublic} [translateInputPublic] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postTranslatePublic(productId: number, storeId: number, lang?: string, translateInputPublic?: TranslateInputPublic, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TranslateOutputPublic>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postTranslatePublic(productId, storeId, lang, translateInputPublic, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * IntegrationL10nLionatApi - factory interface
 * @export
 */
export const IntegrationL10nLionatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IntegrationL10nLionatApiFp(configuration)
    return {
        /**
         * Automatic text translation service
         * @summary Automatic text translation service
         * @param {TranslateInput} [translateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTranslatePrivate(translateInput?: TranslateInput, options?: any): AxiosPromise<TranslateOutput> {
            return localVarFp.postTranslatePrivate(translateInput, options).then((request) => request(axios, basePath));
        },
        /**
         * Automatic text translation service
         * @summary Automatic text translation service
         * @param {number} productId 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {TranslateInputPublic} [translateInputPublic] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postTranslatePublic(productId: number, storeId: number, lang?: string, translateInputPublic?: TranslateInputPublic, options?: any): AxiosPromise<TranslateOutputPublic> {
            return localVarFp.postTranslatePublic(productId, storeId, lang, translateInputPublic, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IntegrationL10nLionatApi - interface
 * @export
 * @interface IntegrationL10nLionatApi
 */
export interface IntegrationL10nLionatApiInterface {
    /**
     * Automatic text translation service
     * @summary Automatic text translation service
     * @param {TranslateInput} [translateInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationL10nLionatApiInterface
     */
    postTranslatePrivate(translateInput?: TranslateInput, options?: AxiosRequestConfig): AxiosPromise<TranslateOutput>;

    /**
     * Automatic text translation service
     * @summary Automatic text translation service
     * @param {number} productId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {TranslateInputPublic} [translateInputPublic] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationL10nLionatApiInterface
     */
    postTranslatePublic(productId: number, storeId: number, lang?: string, translateInputPublic?: TranslateInputPublic, options?: AxiosRequestConfig): AxiosPromise<TranslateOutputPublic>;

}

/**
 * IntegrationL10nLionatApi - object-oriented interface
 * @export
 * @class IntegrationL10nLionatApi
 * @extends {BaseAPI}
 */
export class IntegrationL10nLionatApi extends BaseAPI implements IntegrationL10nLionatApiInterface {
    /**
     * Automatic text translation service
     * @summary Automatic text translation service
     * @param {TranslateInput} [translateInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationL10nLionatApi
     */
    public postTranslatePrivate(translateInput?: TranslateInput, options?: AxiosRequestConfig) {
        return IntegrationL10nLionatApiFp(this.configuration).postTranslatePrivate(translateInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Automatic text translation service
     * @summary Automatic text translation service
     * @param {number} productId 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {TranslateInputPublic} [translateInputPublic] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationL10nLionatApi
     */
    public postTranslatePublic(productId: number, storeId: number, lang?: string, translateInputPublic?: TranslateInputPublic, options?: AxiosRequestConfig) {
        return IntegrationL10nLionatApiFp(this.configuration).postTranslatePublic(productId, storeId, lang, translateInputPublic, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RepairApi - axios parameter creator
 * @export
 */
export const RepairApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all types of possible conditions of products
         * @summary Get all types of possible conditions of products
         * @param {string} language language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReapirProductConditionTypes: async (language: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getReapirProductConditionTypes', 'language', language)
            const localVarPath = `/itxrest/2/resell-integration/repair/productConditionTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all types of possible conditions of products
         * @summary Get all types of possible conditions of products
         * @param {string} language language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepairColorTypes: async (language: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getRepairColorTypes', 'language', language)
            const localVarPath = `/itxrest/2/resell-integration/repair/colorTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all fix types with prices
         * @summary Get all fix types with prices
         * @param {number} storeId 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepairFixTypesPrices: async (storeId: number, language: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getRepairFixTypesPrices', 'storeId', storeId)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getRepairFixTypesPrices', 'language', language)
            const localVarPath = `/itxrest/2/resell-integration/repair/store/{storeId}/getFixTypesPrices`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all types of material for products
         * @summary Get all types of material for products
         * @param {string} language language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepairMaterialTypes: async (language: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getRepairMaterialTypes', 'language', language)
            const localVarPath = `/itxrest/2/resell-integration/repair/materialTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all types of products with associated fix information
         * @summary Get all types of products with associated fix information
         * @param {number} storeId 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepairProductFixTypes: async (storeId: number, language: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getRepairProductFixTypes', 'storeId', storeId)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getRepairProductFixTypes', 'language', language)
            const localVarPath = `/itxrest/2/resell-integration/repair/store/{storeId}/getProductFixTypes`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a repair from form page
         * @summary update transaction for repair
         * @param {number} storeId 
         * @param {number} repairId 
         * @param {string} language 
         * @param {RepairOnlinePaymentRequest} [repairOnlinePaymentRequest] repair created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRepairOnlineCreate: async (storeId: number, repairId: number, language: string, repairOnlinePaymentRequest?: RepairOnlinePaymentRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('patchRepairOnlineCreate', 'storeId', storeId)
            // verify required parameter 'repairId' is not null or undefined
            assertParamExists('patchRepairOnlineCreate', 'repairId', repairId)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('patchRepairOnlineCreate', 'language', language)
            const localVarPath = `/itxrest/2/resell-integration/repair/store/{storeId}/repair/{repairId}`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)))
                .replace(`{${"repairId"}}`, encodeURIComponent(String(repairId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairOnlinePaymentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a repair from form page
         * @summary Create repair for store
         * @param {number} storeId 
         * @param {string} language 
         * @param {RepairOnlineRequest} [repairOnlineRequest] repair created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRepairOnlineCreate: async (storeId: number, language: string, repairOnlineRequest?: RepairOnlineRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('postRepairOnlineCreate', 'storeId', storeId)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('postRepairOnlineCreate', 'language', language)
            const localVarPath = `/itxrest/2/resell-integration/repair/store/{storeId}`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(repairOnlineRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RepairApi - functional programming interface
 * @export
 */
export const RepairApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RepairApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all types of possible conditions of products
         * @summary Get all types of possible conditions of products
         * @param {string} language language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReapirProductConditionTypes(language: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductConditionTypeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReapirProductConditionTypes(language, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all types of possible conditions of products
         * @summary Get all types of possible conditions of products
         * @param {string} language language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRepairColorTypes(language: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ColorTypeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRepairColorTypes(language, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all fix types with prices
         * @summary Get all fix types with prices
         * @param {number} storeId 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRepairFixTypesPrices(storeId: number, language: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FixTypePriceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRepairFixTypesPrices(storeId, language, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all types of material for products
         * @summary Get all types of material for products
         * @param {string} language language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRepairMaterialTypes(language: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaterialTypeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRepairMaterialTypes(language, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all types of products with associated fix information
         * @summary Get all types of products with associated fix information
         * @param {number} storeId 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRepairProductFixTypes(storeId: number, language: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductFixTypeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRepairProductFixTypes(storeId, language, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a repair from form page
         * @summary update transaction for repair
         * @param {number} storeId 
         * @param {number} repairId 
         * @param {string} language 
         * @param {RepairOnlinePaymentRequest} [repairOnlinePaymentRequest] repair created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchRepairOnlineCreate(storeId: number, repairId: number, language: string, repairOnlinePaymentRequest?: RepairOnlinePaymentRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairOnline>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchRepairOnlineCreate(storeId, repairId, language, repairOnlinePaymentRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Create a repair from form page
         * @summary Create repair for store
         * @param {number} storeId 
         * @param {string} language 
         * @param {RepairOnlineRequest} [repairOnlineRequest] repair created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postRepairOnlineCreate(storeId: number, language: string, repairOnlineRequest?: RepairOnlineRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RepairOnline>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postRepairOnlineCreate(storeId, language, repairOnlineRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RepairApi - factory interface
 * @export
 */
export const RepairApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RepairApiFp(configuration)
    return {
        /**
         * Get all types of possible conditions of products
         * @summary Get all types of possible conditions of products
         * @param {string} language language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReapirProductConditionTypes(language: string, options?: any): AxiosPromise<ProductConditionTypeResponse> {
            return localVarFp.getReapirProductConditionTypes(language, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all types of possible conditions of products
         * @summary Get all types of possible conditions of products
         * @param {string} language language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepairColorTypes(language: string, options?: any): AxiosPromise<ColorTypeResponse> {
            return localVarFp.getRepairColorTypes(language, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all fix types with prices
         * @summary Get all fix types with prices
         * @param {number} storeId 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepairFixTypesPrices(storeId: number, language: string, options?: any): AxiosPromise<FixTypePriceResponse> {
            return localVarFp.getRepairFixTypesPrices(storeId, language, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all types of material for products
         * @summary Get all types of material for products
         * @param {string} language language code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepairMaterialTypes(language: string, options?: any): AxiosPromise<MaterialTypeResponse> {
            return localVarFp.getRepairMaterialTypes(language, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all types of products with associated fix information
         * @summary Get all types of products with associated fix information
         * @param {number} storeId 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepairProductFixTypes(storeId: number, language: string, options?: any): AxiosPromise<ProductFixTypeResponse> {
            return localVarFp.getRepairProductFixTypes(storeId, language, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a repair from form page
         * @summary update transaction for repair
         * @param {number} storeId 
         * @param {number} repairId 
         * @param {string} language 
         * @param {RepairOnlinePaymentRequest} [repairOnlinePaymentRequest] repair created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchRepairOnlineCreate(storeId: number, repairId: number, language: string, repairOnlinePaymentRequest?: RepairOnlinePaymentRequest, options?: any): AxiosPromise<RepairOnline> {
            return localVarFp.patchRepairOnlineCreate(storeId, repairId, language, repairOnlinePaymentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a repair from form page
         * @summary Create repair for store
         * @param {number} storeId 
         * @param {string} language 
         * @param {RepairOnlineRequest} [repairOnlineRequest] repair created
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postRepairOnlineCreate(storeId: number, language: string, repairOnlineRequest?: RepairOnlineRequest, options?: any): AxiosPromise<RepairOnline> {
            return localVarFp.postRepairOnlineCreate(storeId, language, repairOnlineRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RepairApi - interface
 * @export
 * @interface RepairApi
 */
export interface RepairApiInterface {
    /**
     * Get all types of possible conditions of products
     * @summary Get all types of possible conditions of products
     * @param {string} language language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairApiInterface
     */
    getReapirProductConditionTypes(language: string, options?: AxiosRequestConfig): AxiosPromise<ProductConditionTypeResponse>;

    /**
     * Get all types of possible conditions of products
     * @summary Get all types of possible conditions of products
     * @param {string} language language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairApiInterface
     */
    getRepairColorTypes(language: string, options?: AxiosRequestConfig): AxiosPromise<ColorTypeResponse>;

    /**
     * Get all fix types with prices
     * @summary Get all fix types with prices
     * @param {number} storeId 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairApiInterface
     */
    getRepairFixTypesPrices(storeId: number, language: string, options?: AxiosRequestConfig): AxiosPromise<FixTypePriceResponse>;

    /**
     * Get all types of material for products
     * @summary Get all types of material for products
     * @param {string} language language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairApiInterface
     */
    getRepairMaterialTypes(language: string, options?: AxiosRequestConfig): AxiosPromise<MaterialTypeResponse>;

    /**
     * Get all types of products with associated fix information
     * @summary Get all types of products with associated fix information
     * @param {number} storeId 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairApiInterface
     */
    getRepairProductFixTypes(storeId: number, language: string, options?: AxiosRequestConfig): AxiosPromise<ProductFixTypeResponse>;

    /**
     * Create a repair from form page
     * @summary update transaction for repair
     * @param {number} storeId 
     * @param {number} repairId 
     * @param {string} language 
     * @param {RepairOnlinePaymentRequest} [repairOnlinePaymentRequest] repair created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairApiInterface
     */
    patchRepairOnlineCreate(storeId: number, repairId: number, language: string, repairOnlinePaymentRequest?: RepairOnlinePaymentRequest, options?: AxiosRequestConfig): AxiosPromise<RepairOnline>;

    /**
     * Create a repair from form page
     * @summary Create repair for store
     * @param {number} storeId 
     * @param {string} language 
     * @param {RepairOnlineRequest} [repairOnlineRequest] repair created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairApiInterface
     */
    postRepairOnlineCreate(storeId: number, language: string, repairOnlineRequest?: RepairOnlineRequest, options?: AxiosRequestConfig): AxiosPromise<RepairOnline>;

}

/**
 * RepairApi - object-oriented interface
 * @export
 * @class RepairApi
 * @extends {BaseAPI}
 */
export class RepairApi extends BaseAPI implements RepairApiInterface {
    /**
     * Get all types of possible conditions of products
     * @summary Get all types of possible conditions of products
     * @param {string} language language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairApi
     */
    public getReapirProductConditionTypes(language: string, options?: AxiosRequestConfig) {
        return RepairApiFp(this.configuration).getReapirProductConditionTypes(language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all types of possible conditions of products
     * @summary Get all types of possible conditions of products
     * @param {string} language language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairApi
     */
    public getRepairColorTypes(language: string, options?: AxiosRequestConfig) {
        return RepairApiFp(this.configuration).getRepairColorTypes(language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all fix types with prices
     * @summary Get all fix types with prices
     * @param {number} storeId 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairApi
     */
    public getRepairFixTypesPrices(storeId: number, language: string, options?: AxiosRequestConfig) {
        return RepairApiFp(this.configuration).getRepairFixTypesPrices(storeId, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all types of material for products
     * @summary Get all types of material for products
     * @param {string} language language code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairApi
     */
    public getRepairMaterialTypes(language: string, options?: AxiosRequestConfig) {
        return RepairApiFp(this.configuration).getRepairMaterialTypes(language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all types of products with associated fix information
     * @summary Get all types of products with associated fix information
     * @param {number} storeId 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairApi
     */
    public getRepairProductFixTypes(storeId: number, language: string, options?: AxiosRequestConfig) {
        return RepairApiFp(this.configuration).getRepairProductFixTypes(storeId, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a repair from form page
     * @summary update transaction for repair
     * @param {number} storeId 
     * @param {number} repairId 
     * @param {string} language 
     * @param {RepairOnlinePaymentRequest} [repairOnlinePaymentRequest] repair created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairApi
     */
    public patchRepairOnlineCreate(storeId: number, repairId: number, language: string, repairOnlinePaymentRequest?: RepairOnlinePaymentRequest, options?: AxiosRequestConfig) {
        return RepairApiFp(this.configuration).patchRepairOnlineCreate(storeId, repairId, language, repairOnlinePaymentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a repair from form page
     * @summary Create repair for store
     * @param {number} storeId 
     * @param {string} language 
     * @param {RepairOnlineRequest} [repairOnlineRequest] repair created
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RepairApi
     */
    public postRepairOnlineCreate(storeId: number, language: string, repairOnlineRequest?: RepairOnlineRequest, options?: AxiosRequestConfig) {
        return RepairApiFp(this.configuration).postRepairOnlineCreate(storeId, language, repairOnlineRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ResellAdminApi - axios parameter creator
 * @export
 */
export const ResellAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getAll', 'storeId', storeId)
            const localVarPath = `/resell-admin/api/v1/admin/rejectReason`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOptionValues: async (storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getAllOptionValues', 'storeId', storeId)
            const localVarPath = `/resell-admin/api/v1/admin/productOptionValue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the stores for which this user has permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorizedStoresAction: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/resell-admin/api/v1/admin/stores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get next product to be moderated
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextProductToReview: async (storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getNextProductToReview', 'storeId', storeId)
            const localVarPath = `/resell-admin/api/v1/admin/moderation/nextproduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get reviewer stats
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewerStats: async (storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getReviewerStats', 'storeId', storeId)
            const localVarPath = `/resell-admin/api/v1/admin/moderation/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List universes
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUniverses: async (storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('listUniverses', 'storeId', storeId)
            const localVarPath = `/api/v1/admin/universes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pause Product
         * @param {number} id 
         * @param {number} storeId ID of the store this query
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseProduct: async (id: number, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pauseProduct', 'id', id)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('pauseProduct', 'storeId', storeId)
            const localVarPath = `/resell-admin/api/v1/admin/moderation/{id}/pause`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResellAdminApi - functional programming interface
 * @export
 */
export const ResellAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ResellAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RejectReasonItxDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllOptionValues(storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductOptionValueDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllOptionValues(storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the stores for which this user has permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuthorizedStoresAction(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StoreInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuthorizedStoresAction(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get next product to be moderated
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNextProductToReview(storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NextProductDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNextProductToReview(storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get reviewer stats
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReviewerStats(storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductReviewerStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReviewerStats(storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List universes
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUniverses(storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Universe>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUniverses(storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Pause Product
         * @param {number} id 
         * @param {number} storeId ID of the store this query
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pauseProduct(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pauseProduct(id, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ResellAdminApi - factory interface
 * @export
 */
export const ResellAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ResellAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(storeId: number, lang?: string, options?: any): AxiosPromise<Array<RejectReasonItxDto>> {
            return localVarFp.getAll(storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllOptionValues(storeId: number, lang?: string, options?: any): AxiosPromise<Array<ProductOptionValueDto>> {
            return localVarFp.getAllOptionValues(storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the stores for which this user has permissions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorizedStoresAction(options?: any): AxiosPromise<Array<StoreInfo>> {
            return localVarFp.getAuthorizedStoresAction(options).then((request) => request(axios, basePath));
        },
        /**
         * Get next product to be moderated
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNextProductToReview(storeId: number, lang?: string, options?: any): AxiosPromise<NextProductDto> {
            return localVarFp.getNextProductToReview(storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Get reviewer stats
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewerStats(storeId: number, lang?: string, options?: any): AxiosPromise<ProductReviewerStats> {
            return localVarFp.getReviewerStats(storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List universes
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUniverses(storeId: number, lang?: string, options?: any): AxiosPromise<Array<Universe>> {
            return localVarFp.listUniverses(storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Pause Product
         * @param {number} id 
         * @param {number} storeId ID of the store this query
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseProduct(id: number, storeId: number, lang?: string, options?: any): AxiosPromise<void> {
            return localVarFp.pauseProduct(id, storeId, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ResellAdminApi - interface
 * @export
 * @interface ResellAdminApi
 */
export interface ResellAdminApiInterface {
    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAdminApiInterface
     */
    getAll(storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Array<RejectReasonItxDto>>;

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAdminApiInterface
     */
    getAllOptionValues(storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Array<ProductOptionValueDto>>;

    /**
     * Get the stores for which this user has permissions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAdminApiInterface
     */
    getAuthorizedStoresAction(options?: AxiosRequestConfig): AxiosPromise<Array<StoreInfo>>;

    /**
     * Get next product to be moderated
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAdminApiInterface
     */
    getNextProductToReview(storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<NextProductDto>;

    /**
     * Get reviewer stats
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAdminApiInterface
     */
    getReviewerStats(storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<ProductReviewerStats>;

    /**
     * 
     * @summary List universes
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAdminApiInterface
     */
    listUniverses(storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Array<Universe>>;

    /**
     * Pause Product
     * @param {number} id 
     * @param {number} storeId ID of the store this query
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAdminApiInterface
     */
    pauseProduct(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * ResellAdminApi - object-oriented interface
 * @export
 * @class ResellAdminApi
 * @extends {BaseAPI}
 */
export class ResellAdminApi extends BaseAPI implements ResellAdminApiInterface {
    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAdminApi
     */
    public getAll(storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return ResellAdminApiFp(this.configuration).getAll(storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAdminApi
     */
    public getAllOptionValues(storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return ResellAdminApiFp(this.configuration).getAllOptionValues(storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the stores for which this user has permissions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAdminApi
     */
    public getAuthorizedStoresAction(options?: AxiosRequestConfig) {
        return ResellAdminApiFp(this.configuration).getAuthorizedStoresAction(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get next product to be moderated
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAdminApi
     */
    public getNextProductToReview(storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return ResellAdminApiFp(this.configuration).getNextProductToReview(storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get reviewer stats
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAdminApi
     */
    public getReviewerStats(storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return ResellAdminApiFp(this.configuration).getReviewerStats(storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List universes
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAdminApi
     */
    public listUniverses(storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return ResellAdminApiFp(this.configuration).listUniverses(storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Pause Product
     * @param {number} id 
     * @param {number} storeId ID of the store this query
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellAdminApi
     */
    public pauseProduct(id: number, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return ResellAdminApiFp(this.configuration).pauseProduct(id, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ResellCatalogImageApi - axios parameter creator
 * @export
 */
export const ResellCatalogImageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get catalog image by sku
         * @summary Get catalog image by sku
         * @param {string} sku sku for the product requested with format TMMMQQQQCCC-SYYYY
         * @param {number} outfit outfit of the product. Outfits are positive integers starting on 0.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogImageBySku: async (sku: string, outfit: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sku' is not null or undefined
            assertParamExists('getCatalogImageBySku', 'sku', sku)
            // verify required parameter 'outfit' is not null or undefined
            assertParamExists('getCatalogImageBySku', 'outfit', outfit)
            const localVarPath = `/resell-admin/catalog-image/sku/{sku}/outfit/{outfit}`
                .replace(`{${"sku"}}`, encodeURIComponent(String(sku)))
                .replace(`{${"outfit"}}`, encodeURIComponent(String(outfit)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResellCatalogImageApi - functional programming interface
 * @export
 */
export const ResellCatalogImageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ResellCatalogImageApiAxiosParamCreator(configuration)
    return {
        /**
         * Get catalog image by sku
         * @summary Get catalog image by sku
         * @param {string} sku sku for the product requested with format TMMMQQQQCCC-SYYYY
         * @param {number} outfit outfit of the product. Outfits are positive integers starting on 0.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCatalogImageBySku(sku: string, outfit: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LegacyMedia>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCatalogImageBySku(sku, outfit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ResellCatalogImageApi - factory interface
 * @export
 */
export const ResellCatalogImageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ResellCatalogImageApiFp(configuration)
    return {
        /**
         * Get catalog image by sku
         * @summary Get catalog image by sku
         * @param {string} sku sku for the product requested with format TMMMQQQQCCC-SYYYY
         * @param {number} outfit outfit of the product. Outfits are positive integers starting on 0.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogImageBySku(sku: string, outfit: number, options?: any): AxiosPromise<Array<LegacyMedia>> {
            return localVarFp.getCatalogImageBySku(sku, outfit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ResellCatalogImageApi - interface
 * @export
 * @interface ResellCatalogImageApi
 */
export interface ResellCatalogImageApiInterface {
    /**
     * Get catalog image by sku
     * @summary Get catalog image by sku
     * @param {string} sku sku for the product requested with format TMMMQQQQCCC-SYYYY
     * @param {number} outfit outfit of the product. Outfits are positive integers starting on 0.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellCatalogImageApiInterface
     */
    getCatalogImageBySku(sku: string, outfit: number, options?: AxiosRequestConfig): AxiosPromise<Array<LegacyMedia>>;

}

/**
 * ResellCatalogImageApi - object-oriented interface
 * @export
 * @class ResellCatalogImageApi
 * @extends {BaseAPI}
 */
export class ResellCatalogImageApi extends BaseAPI implements ResellCatalogImageApiInterface {
    /**
     * Get catalog image by sku
     * @summary Get catalog image by sku
     * @param {string} sku sku for the product requested with format TMMMQQQQCCC-SYYYY
     * @param {number} outfit outfit of the product. Outfits are positive integers starting on 0.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellCatalogImageApi
     */
    public getCatalogImageBySku(sku: string, outfit: number, options?: AxiosRequestConfig) {
        return ResellCatalogImageApiFp(this.configuration).getCatalogImageBySku(sku, outfit, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ResellGridApi - axios parameter creator
 * @export
 */
export const ResellGridApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Assign subgrids to a grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} universeId Universe ID to search in
         * @param {Array<string>} requestBody Array of grid IDs to assign as children
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignSubgrids: async (gridId: string, storeId: number, universeId: number, requestBody: Array<string>, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('assignSubgrids', 'gridId', gridId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('assignSubgrids', 'storeId', storeId)
            // verify required parameter 'universeId' is not null or undefined
            assertParamExists('assignSubgrids', 'universeId', universeId)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('assignSubgrids', 'requestBody', requestBody)
            const localVarPath = `/resell-admin/v3/grid/{gridId}/children`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (universeId !== undefined) {
                localVarQueryParameter['universeId'] = universeId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new grid
         * @param {number} storeId ID of the store this query is directed to
         * @param {Grid} grid Grid to create
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGrid: async (storeId: number, grid: Grid, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('createGrid', 'storeId', storeId)
            // verify required parameter 'grid' is not null or undefined
            assertParamExists('createGrid', 'grid', grid)
            const localVarPath = `/resell-admin/v3/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(grid, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a grid
         * @param {string} gridId ID of the grid to delete
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGrid: async (gridId: string, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('deleteGrid', 'gridId', gridId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('deleteGrid', 'storeId', storeId)
            const localVarPath = `/resell-admin/v3/grid/{gridId}`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request to evaluate products ar outdated
         * @summary Request to evaluate products ar outdated
         * @param {string} gridId Grid ID
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluateProduct: async (gridId: string, storeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('evaluateProduct', 'gridId', gridId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('evaluateProduct', 'storeId', storeId)
            const localVarPath = `/api/v3/admin/{gridId}/outdated`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get grid contents
         * @summary Get grid by ID
         * @param {string} gridId Grid ID
         * @param {number} storeId ID of the store to search in
         * @param {number} universeId Universe ID to search in
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrid: async (gridId: string, storeId: number, universeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('getGrid', 'gridId', gridId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getGrid', 'storeId', storeId)
            // verify required parameter 'universeId' is not null or undefined
            assertParamExists('getGrid', 'universeId', universeId)
            const localVarPath = `/resell-admin/v3/grid/{gridId}`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (universeId !== undefined) {
                localVarQueryParameter['universeId'] = universeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get grid status
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} universeId Universe ID to search in
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGridStatus: async (gridId: string, storeId: number, universeId: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('getGridStatus', 'gridId', gridId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getGridStatus', 'storeId', storeId)
            // verify required parameter 'universeId' is not null or undefined
            assertParamExists('getGridStatus', 'universeId', universeId)
            const localVarPath = `/resell-admin/v3/grid/{gridId}/status`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (universeId !== undefined) {
                localVarQueryParameter['universeId'] = universeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List grids
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [universeId] 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {boolean} [showOnlyParents] Flag to filter by available parents
         * @param {boolean} [onlyIds] Flag to return only grid IDs
         * @param {boolean} [updatable] Flag to filter grids that can be updated
         * @param {Array<number>} [version] List of grid versions to filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGrids: async (storeId: number, universeId?: number, lang?: string, showOnlyParents?: boolean, onlyIds?: boolean, updatable?: boolean, version?: Array<number>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('listGrids', 'storeId', storeId)
            const localVarPath = `/resell-admin/v3/grid`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (universeId !== undefined) {
                localVarQueryParameter['universeId'] = universeId;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (showOnlyParents !== undefined) {
                localVarQueryParameter['showOnlyParents'] = showOnlyParents;
            }

            if (onlyIds !== undefined) {
                localVarQueryParameter['onlyIds'] = onlyIds;
            }

            if (updatable !== undefined) {
                localVarQueryParameter['updatable'] = updatable;
            }

            if (version) {
                localVarQueryParameter['version'] = version;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Patch grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} universeId Universe ID to search in
         * @param {Grid} grid Grid object to update
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchGrid: async (gridId: string, storeId: number, universeId: number, grid: Grid, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('patchGrid', 'gridId', gridId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('patchGrid', 'storeId', storeId)
            // verify required parameter 'universeId' is not null or undefined
            assertParamExists('patchGrid', 'universeId', universeId)
            // verify required parameter 'grid' is not null or undefined
            assertParamExists('patchGrid', 'grid', grid)
            const localVarPath = `/resell-admin/v3/grid/{gridId}`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (universeId !== undefined) {
                localVarQueryParameter['universeId'] = universeId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(grid, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Clone a grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} universeId Universe ID to search in
         * @param {Grid} grid Grid object to update
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCloneGrid: async (gridId: string, storeId: number, universeId: number, grid: Grid, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('postCloneGrid', 'gridId', gridId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('postCloneGrid', 'storeId', storeId)
            // verify required parameter 'universeId' is not null or undefined
            assertParamExists('postCloneGrid', 'universeId', universeId)
            // verify required parameter 'grid' is not null or undefined
            assertParamExists('postCloneGrid', 'grid', grid)
            const localVarPath = `/resell-admin/v3/grid/{gridId}/clone`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (universeId !== undefined) {
                localVarQueryParameter['universeId'] = universeId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(grid, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Put grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} universeId Universe ID to search in
         * @param {Grid} grid Grid object to update
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putGrid: async (gridId: string, storeId: number, universeId: number, grid: Grid, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('putGrid', 'gridId', gridId)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('putGrid', 'storeId', storeId)
            // verify required parameter 'universeId' is not null or undefined
            assertParamExists('putGrid', 'universeId', universeId)
            // verify required parameter 'grid' is not null or undefined
            assertParamExists('putGrid', 'grid', grid)
            const localVarPath = `/resell-admin/v3/grid/{gridId}`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (universeId !== undefined) {
                localVarQueryParameter['universeId'] = universeId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(grid, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Request to remove and add product group ids
         * @summary Update product group ids
         * @param {string} gridId Grid ID
         * @param {ProductGroup} productGroup services object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductGroup: async (gridId: string, productGroup: ProductGroup, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'gridId' is not null or undefined
            assertParamExists('updateProductGroup', 'gridId', gridId)
            // verify required parameter 'productGroup' is not null or undefined
            assertParamExists('updateProductGroup', 'productGroup', productGroup)
            const localVarPath = `/api/v3/admin/grids/{gridId}/group`
                .replace(`{${"gridId"}}`, encodeURIComponent(String(gridId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productGroup, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResellGridApi - functional programming interface
 * @export
 */
export const ResellGridApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ResellGridApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Assign subgrids to a grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} universeId Universe ID to search in
         * @param {Array<string>} requestBody Array of grid IDs to assign as children
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignSubgrids(gridId: string, storeId: number, universeId: number, requestBody: Array<string>, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Grid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignSubgrids(gridId, storeId, universeId, requestBody, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a new grid
         * @param {number} storeId ID of the store this query is directed to
         * @param {Grid} grid Grid to create
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createGrid(storeId: number, grid: Grid, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Grid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createGrid(storeId, grid, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a grid
         * @param {string} gridId ID of the grid to delete
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteGrid(gridId: string, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteGrid(gridId, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Request to evaluate products ar outdated
         * @summary Request to evaluate products ar outdated
         * @param {string} gridId Grid ID
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async evaluateProduct(gridId: string, storeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductOut>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.evaluateProduct(gridId, storeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get grid contents
         * @summary Get grid by ID
         * @param {string} gridId Grid ID
         * @param {number} storeId ID of the store to search in
         * @param {number} universeId Universe ID to search in
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGrid(gridId: string, storeId: number, universeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Grid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGrid(gridId, storeId, universeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get grid status
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} universeId Universe ID to search in
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGridStatus(gridId: string, storeId: number, universeId: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GridStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGridStatus(gridId, storeId, universeId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List grids
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [universeId] 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {boolean} [showOnlyParents] Flag to filter by available parents
         * @param {boolean} [onlyIds] Flag to return only grid IDs
         * @param {boolean} [updatable] Flag to filter grids that can be updated
         * @param {Array<number>} [version] List of grid versions to filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listGrids(storeId: number, universeId?: number, lang?: string, showOnlyParents?: boolean, onlyIds?: boolean, updatable?: boolean, version?: Array<number>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Grid>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listGrids(storeId, universeId, lang, showOnlyParents, onlyIds, updatable, version, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Patch grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} universeId Universe ID to search in
         * @param {Grid} grid Grid object to update
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchGrid(gridId: string, storeId: number, universeId: number, grid: Grid, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Grid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchGrid(gridId, storeId, universeId, grid, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Clone a grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} universeId Universe ID to search in
         * @param {Grid} grid Grid object to update
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCloneGrid(gridId: string, storeId: number, universeId: number, grid: Grid, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Grid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCloneGrid(gridId, storeId, universeId, grid, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Put grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} universeId Universe ID to search in
         * @param {Grid} grid Grid object to update
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putGrid(gridId: string, storeId: number, universeId: number, grid: Grid, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Grid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putGrid(gridId, storeId, universeId, grid, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Request to remove and add product group ids
         * @summary Update product group ids
         * @param {string} gridId Grid ID
         * @param {ProductGroup} productGroup services object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductGroup(gridId: string, productGroup: ProductGroup, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductGroup(gridId, productGroup, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ResellGridApi - factory interface
 * @export
 */
export const ResellGridApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ResellGridApiFp(configuration)
    return {
        /**
         * 
         * @summary Assign subgrids to a grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} universeId Universe ID to search in
         * @param {Array<string>} requestBody Array of grid IDs to assign as children
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignSubgrids(gridId: string, storeId: number, universeId: number, requestBody: Array<string>, lang?: string, options?: any): AxiosPromise<Grid> {
            return localVarFp.assignSubgrids(gridId, storeId, universeId, requestBody, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new grid
         * @param {number} storeId ID of the store this query is directed to
         * @param {Grid} grid Grid to create
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGrid(storeId: number, grid: Grid, lang?: string, options?: any): AxiosPromise<Grid> {
            return localVarFp.createGrid(storeId, grid, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a grid
         * @param {string} gridId ID of the grid to delete
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGrid(gridId: string, storeId: number, lang?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteGrid(gridId, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Request to evaluate products ar outdated
         * @summary Request to evaluate products ar outdated
         * @param {string} gridId Grid ID
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        evaluateProduct(gridId: string, storeId: number, lang?: string, options?: any): AxiosPromise<ProductOut> {
            return localVarFp.evaluateProduct(gridId, storeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Get grid contents
         * @summary Get grid by ID
         * @param {string} gridId Grid ID
         * @param {number} storeId ID of the store to search in
         * @param {number} universeId Universe ID to search in
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGrid(gridId: string, storeId: number, universeId: number, lang?: string, options?: any): AxiosPromise<Grid> {
            return localVarFp.getGrid(gridId, storeId, universeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get grid status
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} universeId Universe ID to search in
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGridStatus(gridId: string, storeId: number, universeId: number, lang?: string, options?: any): AxiosPromise<GridStatus> {
            return localVarFp.getGridStatus(gridId, storeId, universeId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List grids
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} [universeId] 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {boolean} [showOnlyParents] Flag to filter by available parents
         * @param {boolean} [onlyIds] Flag to return only grid IDs
         * @param {boolean} [updatable] Flag to filter grids that can be updated
         * @param {Array<number>} [version] List of grid versions to filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listGrids(storeId: number, universeId?: number, lang?: string, showOnlyParents?: boolean, onlyIds?: boolean, updatable?: boolean, version?: Array<number>, options?: any): AxiosPromise<Array<Grid>> {
            return localVarFp.listGrids(storeId, universeId, lang, showOnlyParents, onlyIds, updatable, version, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Patch grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} universeId Universe ID to search in
         * @param {Grid} grid Grid object to update
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchGrid(gridId: string, storeId: number, universeId: number, grid: Grid, lang?: string, options?: any): AxiosPromise<Grid> {
            return localVarFp.patchGrid(gridId, storeId, universeId, grid, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Clone a grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} universeId Universe ID to search in
         * @param {Grid} grid Grid object to update
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCloneGrid(gridId: string, storeId: number, universeId: number, grid: Grid, lang?: string, options?: any): AxiosPromise<Grid> {
            return localVarFp.postCloneGrid(gridId, storeId, universeId, grid, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Put grid
         * @param {string} gridId ID of the grid which parents will be assigned to
         * @param {number} storeId ID of the store this query is directed to
         * @param {number} universeId Universe ID to search in
         * @param {Grid} grid Grid object to update
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putGrid(gridId: string, storeId: number, universeId: number, grid: Grid, lang?: string, options?: any): AxiosPromise<Grid> {
            return localVarFp.putGrid(gridId, storeId, universeId, grid, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Request to remove and add product group ids
         * @summary Update product group ids
         * @param {string} gridId Grid ID
         * @param {ProductGroup} productGroup services object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductGroup(gridId: string, productGroup: ProductGroup, options?: any): AxiosPromise<void> {
            return localVarFp.updateProductGroup(gridId, productGroup, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ResellGridApi - interface
 * @export
 * @interface ResellGridApi
 */
export interface ResellGridApiInterface {
    /**
     * 
     * @summary Assign subgrids to a grid
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} universeId Universe ID to search in
     * @param {Array<string>} requestBody Array of grid IDs to assign as children
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellGridApiInterface
     */
    assignSubgrids(gridId: string, storeId: number, universeId: number, requestBody: Array<string>, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Grid>;

    /**
     * 
     * @summary Create a new grid
     * @param {number} storeId ID of the store this query is directed to
     * @param {Grid} grid Grid to create
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellGridApiInterface
     */
    createGrid(storeId: number, grid: Grid, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Grid>;

    /**
     * 
     * @summary Delete a grid
     * @param {string} gridId ID of the grid to delete
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellGridApiInterface
     */
    deleteGrid(gridId: string, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<void>;

    /**
     * Request to evaluate products ar outdated
     * @summary Request to evaluate products ar outdated
     * @param {string} gridId Grid ID
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellGridApiInterface
     */
    evaluateProduct(gridId: string, storeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<ProductOut>;

    /**
     * Get grid contents
     * @summary Get grid by ID
     * @param {string} gridId Grid ID
     * @param {number} storeId ID of the store to search in
     * @param {number} universeId Universe ID to search in
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellGridApiInterface
     */
    getGrid(gridId: string, storeId: number, universeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Grid>;

    /**
     * 
     * @summary Get grid status
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} universeId Universe ID to search in
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellGridApiInterface
     */
    getGridStatus(gridId: string, storeId: number, universeId: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<GridStatus>;

    /**
     * 
     * @summary List grids
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [universeId] 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {boolean} [showOnlyParents] Flag to filter by available parents
     * @param {boolean} [onlyIds] Flag to return only grid IDs
     * @param {boolean} [updatable] Flag to filter grids that can be updated
     * @param {Array<number>} [version] List of grid versions to filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellGridApiInterface
     */
    listGrids(storeId: number, universeId?: number, lang?: string, showOnlyParents?: boolean, onlyIds?: boolean, updatable?: boolean, version?: Array<number>, options?: AxiosRequestConfig): AxiosPromise<Array<Grid>>;

    /**
     * 
     * @summary Patch grid
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} universeId Universe ID to search in
     * @param {Grid} grid Grid object to update
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellGridApiInterface
     */
    patchGrid(gridId: string, storeId: number, universeId: number, grid: Grid, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Grid>;

    /**
     * 
     * @summary Clone a grid
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} universeId Universe ID to search in
     * @param {Grid} grid Grid object to update
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellGridApiInterface
     */
    postCloneGrid(gridId: string, storeId: number, universeId: number, grid: Grid, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Grid>;

    /**
     * 
     * @summary Put grid
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} universeId Universe ID to search in
     * @param {Grid} grid Grid object to update
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellGridApiInterface
     */
    putGrid(gridId: string, storeId: number, universeId: number, grid: Grid, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Grid>;

    /**
     * Request to remove and add product group ids
     * @summary Update product group ids
     * @param {string} gridId Grid ID
     * @param {ProductGroup} productGroup services object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellGridApiInterface
     */
    updateProductGroup(gridId: string, productGroup: ProductGroup, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * ResellGridApi - object-oriented interface
 * @export
 * @class ResellGridApi
 * @extends {BaseAPI}
 */
export class ResellGridApi extends BaseAPI implements ResellGridApiInterface {
    /**
     * 
     * @summary Assign subgrids to a grid
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} universeId Universe ID to search in
     * @param {Array<string>} requestBody Array of grid IDs to assign as children
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellGridApi
     */
    public assignSubgrids(gridId: string, storeId: number, universeId: number, requestBody: Array<string>, lang?: string, options?: AxiosRequestConfig) {
        return ResellGridApiFp(this.configuration).assignSubgrids(gridId, storeId, universeId, requestBody, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new grid
     * @param {number} storeId ID of the store this query is directed to
     * @param {Grid} grid Grid to create
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellGridApi
     */
    public createGrid(storeId: number, grid: Grid, lang?: string, options?: AxiosRequestConfig) {
        return ResellGridApiFp(this.configuration).createGrid(storeId, grid, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a grid
     * @param {string} gridId ID of the grid to delete
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellGridApi
     */
    public deleteGrid(gridId: string, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return ResellGridApiFp(this.configuration).deleteGrid(gridId, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Request to evaluate products ar outdated
     * @summary Request to evaluate products ar outdated
     * @param {string} gridId Grid ID
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellGridApi
     */
    public evaluateProduct(gridId: string, storeId: number, lang?: string, options?: AxiosRequestConfig) {
        return ResellGridApiFp(this.configuration).evaluateProduct(gridId, storeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get grid contents
     * @summary Get grid by ID
     * @param {string} gridId Grid ID
     * @param {number} storeId ID of the store to search in
     * @param {number} universeId Universe ID to search in
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellGridApi
     */
    public getGrid(gridId: string, storeId: number, universeId: number, lang?: string, options?: AxiosRequestConfig) {
        return ResellGridApiFp(this.configuration).getGrid(gridId, storeId, universeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get grid status
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} universeId Universe ID to search in
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellGridApi
     */
    public getGridStatus(gridId: string, storeId: number, universeId: number, lang?: string, options?: AxiosRequestConfig) {
        return ResellGridApiFp(this.configuration).getGridStatus(gridId, storeId, universeId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List grids
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} [universeId] 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {boolean} [showOnlyParents] Flag to filter by available parents
     * @param {boolean} [onlyIds] Flag to return only grid IDs
     * @param {boolean} [updatable] Flag to filter grids that can be updated
     * @param {Array<number>} [version] List of grid versions to filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellGridApi
     */
    public listGrids(storeId: number, universeId?: number, lang?: string, showOnlyParents?: boolean, onlyIds?: boolean, updatable?: boolean, version?: Array<number>, options?: AxiosRequestConfig) {
        return ResellGridApiFp(this.configuration).listGrids(storeId, universeId, lang, showOnlyParents, onlyIds, updatable, version, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Patch grid
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} universeId Universe ID to search in
     * @param {Grid} grid Grid object to update
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellGridApi
     */
    public patchGrid(gridId: string, storeId: number, universeId: number, grid: Grid, lang?: string, options?: AxiosRequestConfig) {
        return ResellGridApiFp(this.configuration).patchGrid(gridId, storeId, universeId, grid, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Clone a grid
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} universeId Universe ID to search in
     * @param {Grid} grid Grid object to update
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellGridApi
     */
    public postCloneGrid(gridId: string, storeId: number, universeId: number, grid: Grid, lang?: string, options?: AxiosRequestConfig) {
        return ResellGridApiFp(this.configuration).postCloneGrid(gridId, storeId, universeId, grid, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Put grid
     * @param {string} gridId ID of the grid which parents will be assigned to
     * @param {number} storeId ID of the store this query is directed to
     * @param {number} universeId Universe ID to search in
     * @param {Grid} grid Grid object to update
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellGridApi
     */
    public putGrid(gridId: string, storeId: number, universeId: number, grid: Grid, lang?: string, options?: AxiosRequestConfig) {
        return ResellGridApiFp(this.configuration).putGrid(gridId, storeId, universeId, grid, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Request to remove and add product group ids
     * @summary Update product group ids
     * @param {string} gridId Grid ID
     * @param {ProductGroup} productGroup services object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellGridApi
     */
    public updateProductGroup(gridId: string, productGroup: ProductGroup, options?: AxiosRequestConfig) {
        return ResellGridApiFp(this.configuration).updateProductGroup(gridId, productGroup, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ResellModerationApi - axios parameter creator
 * @export
 */
export const ResellModerationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Accept product listing review
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {ModerationAcceptPayloadMessage} moderationAcceptPayloadMessage 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptProductReview: async (id: number, storeId: number, moderationAcceptPayloadMessage: ModerationAcceptPayloadMessage, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('acceptProductReview', 'id', id)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('acceptProductReview', 'storeId', storeId)
            // verify required parameter 'moderationAcceptPayloadMessage' is not null or undefined
            assertParamExists('acceptProductReview', 'moderationAcceptPayloadMessage', moderationAcceptPayloadMessage)
            const localVarPath = `/resell-admin/moderation/{id}/accept`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moderationAcceptPayloadMessage, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reject product listing review
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {Array<ReasonItxDto>} [reasonItxDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectProductReview: async (id: number, storeId: number, lang?: string, reasonItxDto?: Array<ReasonItxDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('rejectProductReview', 'id', id)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('rejectProductReview', 'storeId', storeId)
            const localVarPath = `/resell-admin/moderation/{id}/reject`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reasonItxDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResellModerationApi - functional programming interface
 * @export
 */
export const ResellModerationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ResellModerationApiAxiosParamCreator(configuration)
    return {
        /**
         * Accept product listing review
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {ModerationAcceptPayloadMessage} moderationAcceptPayloadMessage 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptProductReview(id: number, storeId: number, moderationAcceptPayloadMessage: ModerationAcceptPayloadMessage, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptProductReview(id, storeId, moderationAcceptPayloadMessage, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Reject product listing review
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {Array<ReasonItxDto>} [reasonItxDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rejectProductReview(id: number, storeId: number, lang?: string, reasonItxDto?: Array<ReasonItxDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Product>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rejectProductReview(id, storeId, lang, reasonItxDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ResellModerationApi - factory interface
 * @export
 */
export const ResellModerationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ResellModerationApiFp(configuration)
    return {
        /**
         * Accept product listing review
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {ModerationAcceptPayloadMessage} moderationAcceptPayloadMessage 
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptProductReview(id: number, storeId: number, moderationAcceptPayloadMessage: ModerationAcceptPayloadMessage, lang?: string, options?: any): AxiosPromise<Product> {
            return localVarFp.acceptProductReview(id, storeId, moderationAcceptPayloadMessage, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * Reject product listing review
         * @param {number} id 
         * @param {number} storeId ID of the store this query is directed to
         * @param {string} [lang] ISO 639-1 code for the desired response language
         * @param {Array<ReasonItxDto>} [reasonItxDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rejectProductReview(id: number, storeId: number, lang?: string, reasonItxDto?: Array<ReasonItxDto>, options?: any): AxiosPromise<Product> {
            return localVarFp.rejectProductReview(id, storeId, lang, reasonItxDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ResellModerationApi - interface
 * @export
 * @interface ResellModerationApi
 */
export interface ResellModerationApiInterface {
    /**
     * Accept product listing review
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {ModerationAcceptPayloadMessage} moderationAcceptPayloadMessage 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellModerationApiInterface
     */
    acceptProductReview(id: number, storeId: number, moderationAcceptPayloadMessage: ModerationAcceptPayloadMessage, lang?: string, options?: AxiosRequestConfig): AxiosPromise<Product>;

    /**
     * Reject product listing review
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {Array<ReasonItxDto>} [reasonItxDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellModerationApiInterface
     */
    rejectProductReview(id: number, storeId: number, lang?: string, reasonItxDto?: Array<ReasonItxDto>, options?: AxiosRequestConfig): AxiosPromise<Product>;

}

/**
 * ResellModerationApi - object-oriented interface
 * @export
 * @class ResellModerationApi
 * @extends {BaseAPI}
 */
export class ResellModerationApi extends BaseAPI implements ResellModerationApiInterface {
    /**
     * Accept product listing review
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {ModerationAcceptPayloadMessage} moderationAcceptPayloadMessage 
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellModerationApi
     */
    public acceptProductReview(id: number, storeId: number, moderationAcceptPayloadMessage: ModerationAcceptPayloadMessage, lang?: string, options?: AxiosRequestConfig) {
        return ResellModerationApiFp(this.configuration).acceptProductReview(id, storeId, moderationAcceptPayloadMessage, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reject product listing review
     * @param {number} id 
     * @param {number} storeId ID of the store this query is directed to
     * @param {string} [lang] ISO 639-1 code for the desired response language
     * @param {Array<ReasonItxDto>} [reasonItxDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellModerationApi
     */
    public rejectProductReview(id: number, storeId: number, lang?: string, reasonItxDto?: Array<ReasonItxDto>, options?: AxiosRequestConfig) {
        return ResellModerationApiFp(this.configuration).rejectProductReview(id, storeId, lang, reasonItxDto, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ResellPrerenderApi - axios parameter creator
 * @export
 */
export const ResellPrerenderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Request to upload and load a sitemap XML file for prerendering
         * @summary Loads a sitemap XML file for prerendering
         * @param {File} file Sitemap XML file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadSitemap: async (file: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('loadSitemap', 'file', file)
            const localVarPath = `/resell-integration/prerender/sitemap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResellPrerenderApi - functional programming interface
 * @export
 */
export const ResellPrerenderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ResellPrerenderApiAxiosParamCreator(configuration)
    return {
        /**
         * Request to upload and load a sitemap XML file for prerendering
         * @summary Loads a sitemap XML file for prerendering
         * @param {File} file Sitemap XML file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loadSitemap(file: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loadSitemap(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ResellPrerenderApi - factory interface
 * @export
 */
export const ResellPrerenderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ResellPrerenderApiFp(configuration)
    return {
        /**
         * Request to upload and load a sitemap XML file for prerendering
         * @summary Loads a sitemap XML file for prerendering
         * @param {File} file Sitemap XML file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loadSitemap(file: File, options?: any): AxiosPromise<void> {
            return localVarFp.loadSitemap(file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ResellPrerenderApi - interface
 * @export
 * @interface ResellPrerenderApi
 */
export interface ResellPrerenderApiInterface {
    /**
     * Request to upload and load a sitemap XML file for prerendering
     * @summary Loads a sitemap XML file for prerendering
     * @param {File} file Sitemap XML file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellPrerenderApiInterface
     */
    loadSitemap(file: File, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * ResellPrerenderApi - object-oriented interface
 * @export
 * @class ResellPrerenderApi
 * @extends {BaseAPI}
 */
export class ResellPrerenderApi extends BaseAPI implements ResellPrerenderApiInterface {
    /**
     * Request to upload and load a sitemap XML file for prerendering
     * @summary Loads a sitemap XML file for prerendering
     * @param {File} file Sitemap XML file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellPrerenderApi
     */
    public loadSitemap(file: File, options?: AxiosRequestConfig) {
        return ResellPrerenderApiFp(this.configuration).loadSitemap(file, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ResellRetouchApi - axios parameter creator
 * @export
 */
export const ResellRetouchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List all images to retouch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListImagesToRetouch: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/resell-admin/retouch/amanda-info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retouch image
         * @param {File} image 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retouchImageCover: async (image: File, productId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'image' is not null or undefined
            assertParamExists('retouchImageCover', 'image', image)
            // verify required parameter 'productId' is not null or undefined
            assertParamExists('retouchImageCover', 'productId', productId)
            const localVarPath = `/resell-admin/retouch/image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (image !== undefined) { 
                localVarFormParams.append('image', image as any);
            }
    
            if (productId !== undefined) { 
                localVarFormParams.append('productId', productId as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResellRetouchApi - functional programming interface
 * @export
 */
export const ResellRetouchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ResellRetouchApiAxiosParamCreator(configuration)
    return {
        /**
         * List all images to retouch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getListImagesToRetouch(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RetouchDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getListImagesToRetouch(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Retouch image
         * @param {File} image 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async retouchImageCover(image: File, productId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.retouchImageCover(image, productId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ResellRetouchApi - factory interface
 * @export
 */
export const ResellRetouchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ResellRetouchApiFp(configuration)
    return {
        /**
         * List all images to retouch
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getListImagesToRetouch(options?: any): AxiosPromise<Array<RetouchDto>> {
            return localVarFp.getListImagesToRetouch(options).then((request) => request(axios, basePath));
        },
        /**
         * Retouch image
         * @param {File} image 
         * @param {number} productId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retouchImageCover(image: File, productId: number, options?: any): AxiosPromise<void> {
            return localVarFp.retouchImageCover(image, productId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ResellRetouchApi - interface
 * @export
 * @interface ResellRetouchApi
 */
export interface ResellRetouchApiInterface {
    /**
     * List all images to retouch
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellRetouchApiInterface
     */
    getListImagesToRetouch(options?: AxiosRequestConfig): AxiosPromise<Array<RetouchDto>>;

    /**
     * Retouch image
     * @param {File} image 
     * @param {number} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellRetouchApiInterface
     */
    retouchImageCover(image: File, productId: number, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * ResellRetouchApi - object-oriented interface
 * @export
 * @class ResellRetouchApi
 * @extends {BaseAPI}
 */
export class ResellRetouchApi extends BaseAPI implements ResellRetouchApiInterface {
    /**
     * List all images to retouch
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellRetouchApi
     */
    public getListImagesToRetouch(options?: AxiosRequestConfig) {
        return ResellRetouchApiFp(this.configuration).getListImagesToRetouch(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retouch image
     * @param {File} image 
     * @param {number} productId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellRetouchApi
     */
    public retouchImageCover(image: File, productId: number, options?: AxiosRequestConfig) {
        return ResellRetouchApiFp(this.configuration).retouchImageCover(image, productId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ResellSearchApi - axios parameter creator
 * @export
 */
export const ResellSearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Search products groups based on query parameters
         * @summary Search product groups
         * @param {string} lang ISO 639-1 code for the desired response language
         * @param {number} storeId ID of the store this query is directed to
         * @param {SearchProductCriteria} searchProductCriteria 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProductsGroups: async (lang: string, storeId: number, searchProductCriteria: SearchProductCriteria, page?: number, size?: number, sort?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lang' is not null or undefined
            assertParamExists('searchProductsGroups', 'lang', lang)
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('searchProductsGroups', 'storeId', storeId)
            // verify required parameter 'searchProductCriteria' is not null or undefined
            assertParamExists('searchProductsGroups', 'searchProductCriteria', searchProductCriteria)
            const localVarPath = `/itxrest/2/resell-integration/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(searchProductCriteria, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ResellSearchApi - functional programming interface
 * @export
 */
export const ResellSearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ResellSearchApiAxiosParamCreator(configuration)
    return {
        /**
         * Search products groups based on query parameters
         * @summary Search product groups
         * @param {string} lang ISO 639-1 code for the desired response language
         * @param {number} storeId ID of the store this query is directed to
         * @param {SearchProductCriteria} searchProductCriteria 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchProductsGroups(lang: string, storeId: number, searchProductCriteria: SearchProductCriteria, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageProductGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchProductsGroups(lang, storeId, searchProductCriteria, page, size, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ResellSearchApi - factory interface
 * @export
 */
export const ResellSearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ResellSearchApiFp(configuration)
    return {
        /**
         * Search products groups based on query parameters
         * @summary Search product groups
         * @param {string} lang ISO 639-1 code for the desired response language
         * @param {number} storeId ID of the store this query is directed to
         * @param {SearchProductCriteria} searchProductCriteria 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProductsGroups(lang: string, storeId: number, searchProductCriteria: SearchProductCriteria, page?: number, size?: number, sort?: Array<string>, options?: any): AxiosPromise<PageProductGroup> {
            return localVarFp.searchProductsGroups(lang, storeId, searchProductCriteria, page, size, sort, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ResellSearchApi - interface
 * @export
 * @interface ResellSearchApi
 */
export interface ResellSearchApiInterface {
    /**
     * Search products groups based on query parameters
     * @summary Search product groups
     * @param {string} lang ISO 639-1 code for the desired response language
     * @param {number} storeId ID of the store this query is directed to
     * @param {SearchProductCriteria} searchProductCriteria 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellSearchApiInterface
     */
    searchProductsGroups(lang: string, storeId: number, searchProductCriteria: SearchProductCriteria, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig): AxiosPromise<PageProductGroup>;

}

/**
 * ResellSearchApi - object-oriented interface
 * @export
 * @class ResellSearchApi
 * @extends {BaseAPI}
 */
export class ResellSearchApi extends BaseAPI implements ResellSearchApiInterface {
    /**
     * Search products groups based on query parameters
     * @summary Search product groups
     * @param {string} lang ISO 639-1 code for the desired response language
     * @param {number} storeId ID of the store this query is directed to
     * @param {SearchProductCriteria} searchProductCriteria 
     * @param {number} [page] Zero-based page index (0..N)
     * @param {number} [size] The size of the page to be returned
     * @param {Array<string>} [sort] Sorting criteria in the format: property(,asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellSearchApi
     */
    public searchProductsGroups(lang: string, storeId: number, searchProductCriteria: SearchProductCriteria, page?: number, size?: number, sort?: Array<string>, options?: AxiosRequestConfig) {
        return ResellSearchApiFp(this.configuration).searchProductsGroups(lang, storeId, searchProductCriteria, page, size, sort, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ShippingCostApi - axios parameter creator
 * @export
 */
export const ShippingCostApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get shipping cost
         * @summary Get shipping cost
         * @param {number} storeId 
         * @param {string} language 
         * @param {'REPAIR' | 'DONATE'} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShippingCost: async (storeId: number, language: string, type: 'REPAIR' | 'DONATE', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getShippingCost', 'storeId', storeId)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getShippingCost', 'language', language)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getShippingCost', 'type', type)
            const localVarPath = `/itxrest/2/resell-integration/repair/store/{storeId}/shippingcost`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ShippingCostApi - functional programming interface
 * @export
 */
export const ShippingCostApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ShippingCostApiAxiosParamCreator(configuration)
    return {
        /**
         * Get shipping cost
         * @summary Get shipping cost
         * @param {number} storeId 
         * @param {string} language 
         * @param {'REPAIR' | 'DONATE'} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getShippingCost(storeId: number, language: string, type: 'REPAIR' | 'DONATE', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ShippingCost>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getShippingCost(storeId, language, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ShippingCostApi - factory interface
 * @export
 */
export const ShippingCostApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ShippingCostApiFp(configuration)
    return {
        /**
         * Get shipping cost
         * @summary Get shipping cost
         * @param {number} storeId 
         * @param {string} language 
         * @param {'REPAIR' | 'DONATE'} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getShippingCost(storeId: number, language: string, type: 'REPAIR' | 'DONATE', options?: any): AxiosPromise<Array<ShippingCost>> {
            return localVarFp.getShippingCost(storeId, language, type, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ShippingCostApi - interface
 * @export
 * @interface ShippingCostApi
 */
export interface ShippingCostApiInterface {
    /**
     * Get shipping cost
     * @summary Get shipping cost
     * @param {number} storeId 
     * @param {string} language 
     * @param {'REPAIR' | 'DONATE'} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingCostApiInterface
     */
    getShippingCost(storeId: number, language: string, type: 'REPAIR' | 'DONATE', options?: AxiosRequestConfig): AxiosPromise<Array<ShippingCost>>;

}

/**
 * ShippingCostApi - object-oriented interface
 * @export
 * @class ShippingCostApi
 * @extends {BaseAPI}
 */
export class ShippingCostApi extends BaseAPI implements ShippingCostApiInterface {
    /**
     * Get shipping cost
     * @summary Get shipping cost
     * @param {number} storeId 
     * @param {string} language 
     * @param {'REPAIR' | 'DONATE'} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingCostApi
     */
    public getShippingCost(storeId: number, language: string, type: 'REPAIR' | 'DONATE', options?: AxiosRequestConfig) {
        return ShippingCostApiFp(this.configuration).getShippingCost(storeId, language, type, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * StoreConfigurationApi - axios parameter creator
 * @export
 */
export const StoreConfigurationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get shipping cost
         * @summary Get shipping cost
         * @param {string} marketIso 
         * @param {string} language 
         * @param {'REPAIR' | 'DONATE'} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicStoreConfiguration: async (marketIso: string, language: string, type: 'REPAIR' | 'DONATE', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'marketIso' is not null or undefined
            assertParamExists('getPublicStoreConfiguration', 'marketIso', marketIso)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getPublicStoreConfiguration', 'language', language)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('getPublicStoreConfiguration', 'type', type)
            const localVarPath = `/itxrest/2/resell-integration/repair/store/{marketIso}/configuration`
                .replace(`{${"marketIso"}}`, encodeURIComponent(String(marketIso)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all states for given store
         * @summary Get all states for given store
         * @param {number} storeId 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStateByStore: async (storeId: number, language: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getStateByStore', 'storeId', storeId)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('getStateByStore', 'language', language)
            const localVarPath = `/itxrest/2/resell-integration/repair/states/{storeId}`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all states for given store
         * @summary Valdiate Address for given store
         * @param {number} storeId 
         * @param {string} language 
         * @param {ValidateAddressRequest} [validateAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postValidateAddress: async (storeId: number, language: string, validateAddressRequest?: ValidateAddressRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('postValidateAddress', 'storeId', storeId)
            // verify required parameter 'language' is not null or undefined
            assertParamExists('postValidateAddress', 'language', language)
            const localVarPath = `/itxrest/2/resell-integration/repair/address/{storeId}/validateAddress`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StoreConfigurationApi - functional programming interface
 * @export
 */
export const StoreConfigurationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StoreConfigurationApiAxiosParamCreator(configuration)
    return {
        /**
         * Get shipping cost
         * @summary Get shipping cost
         * @param {string} marketIso 
         * @param {string} language 
         * @param {'REPAIR' | 'DONATE'} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicStoreConfiguration(marketIso: string, language: string, type: 'REPAIR' | 'DONATE', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StoreConfigurationPublic>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicStoreConfiguration(marketIso, language, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all states for given store
         * @summary Get all states for given store
         * @param {number} storeId 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStateByStore(storeId: number, language: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<State>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStateByStore(storeId, language, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all states for given store
         * @summary Valdiate Address for given store
         * @param {number} storeId 
         * @param {string} language 
         * @param {ValidateAddressRequest} [validateAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postValidateAddress(storeId: number, language: string, validateAddressRequest?: ValidateAddressRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidateAddressResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postValidateAddress(storeId, language, validateAddressRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StoreConfigurationApi - factory interface
 * @export
 */
export const StoreConfigurationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StoreConfigurationApiFp(configuration)
    return {
        /**
         * Get shipping cost
         * @summary Get shipping cost
         * @param {string} marketIso 
         * @param {string} language 
         * @param {'REPAIR' | 'DONATE'} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicStoreConfiguration(marketIso: string, language: string, type: 'REPAIR' | 'DONATE', options?: any): AxiosPromise<StoreConfigurationPublic> {
            return localVarFp.getPublicStoreConfiguration(marketIso, language, type, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all states for given store
         * @summary Get all states for given store
         * @param {number} storeId 
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStateByStore(storeId: number, language: string, options?: any): AxiosPromise<Array<State>> {
            return localVarFp.getStateByStore(storeId, language, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all states for given store
         * @summary Valdiate Address for given store
         * @param {number} storeId 
         * @param {string} language 
         * @param {ValidateAddressRequest} [validateAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postValidateAddress(storeId: number, language: string, validateAddressRequest?: ValidateAddressRequest, options?: any): AxiosPromise<ValidateAddressResponse> {
            return localVarFp.postValidateAddress(storeId, language, validateAddressRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StoreConfigurationApi - interface
 * @export
 * @interface StoreConfigurationApi
 */
export interface StoreConfigurationApiInterface {
    /**
     * Get shipping cost
     * @summary Get shipping cost
     * @param {string} marketIso 
     * @param {string} language 
     * @param {'REPAIR' | 'DONATE'} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreConfigurationApiInterface
     */
    getPublicStoreConfiguration(marketIso: string, language: string, type: 'REPAIR' | 'DONATE', options?: AxiosRequestConfig): AxiosPromise<StoreConfigurationPublic>;

    /**
     * Get all states for given store
     * @summary Get all states for given store
     * @param {number} storeId 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreConfigurationApiInterface
     */
    getStateByStore(storeId: number, language: string, options?: AxiosRequestConfig): AxiosPromise<Array<State>>;

    /**
     * Get all states for given store
     * @summary Valdiate Address for given store
     * @param {number} storeId 
     * @param {string} language 
     * @param {ValidateAddressRequest} [validateAddressRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreConfigurationApiInterface
     */
    postValidateAddress(storeId: number, language: string, validateAddressRequest?: ValidateAddressRequest, options?: AxiosRequestConfig): AxiosPromise<ValidateAddressResponse>;

}

/**
 * StoreConfigurationApi - object-oriented interface
 * @export
 * @class StoreConfigurationApi
 * @extends {BaseAPI}
 */
export class StoreConfigurationApi extends BaseAPI implements StoreConfigurationApiInterface {
    /**
     * Get shipping cost
     * @summary Get shipping cost
     * @param {string} marketIso 
     * @param {string} language 
     * @param {'REPAIR' | 'DONATE'} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreConfigurationApi
     */
    public getPublicStoreConfiguration(marketIso: string, language: string, type: 'REPAIR' | 'DONATE', options?: AxiosRequestConfig) {
        return StoreConfigurationApiFp(this.configuration).getPublicStoreConfiguration(marketIso, language, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all states for given store
     * @summary Get all states for given store
     * @param {number} storeId 
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreConfigurationApi
     */
    public getStateByStore(storeId: number, language: string, options?: AxiosRequestConfig) {
        return StoreConfigurationApiFp(this.configuration).getStateByStore(storeId, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all states for given store
     * @summary Valdiate Address for given store
     * @param {number} storeId 
     * @param {string} language 
     * @param {ValidateAddressRequest} [validateAddressRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StoreConfigurationApi
     */
    public postValidateAddress(storeId: number, language: string, validateAddressRequest?: ValidateAddressRequest, options?: AxiosRequestConfig) {
        return StoreConfigurationApiFp(this.configuration).postValidateAddress(storeId, language, validateAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


